import React, { useState, useEffect } from "react";
import axios from "axios";
import { DOG_BREEDS, CAT_BREEDS, getLocalDateString, isTimeSlotPast, isPetEligibleForGrooming, getPetMinGroomingDate } from "./bookingData";
import { QRCodeSVG } from "qrcode.react";
import { PawIcon, CalendarIcon, CheckIcon, ScissorsIcon } from "./Icons";

/* ── Local dashboard icons ─────────────────────────────────────────────── */
const BellIcon = ({ size = 16, color = "currentColor", className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" className={className}>
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);



const FileTextIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

const GiftIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 12 20 22 4 22 4 12" />
    <rect x="2" y="7" width="20" height="5" />
    <line x1="12" y1="22" x2="12" y2="7" />
    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
  </svg>
);

const CatIcon = ({ size = 28, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5z"/>
    <path d="M8 14v.5"/><path d="M16 14v.5"/>
    <path d="M11.25 16.25h1.5L12 17l-.75-.75z"/>
  </svg>
);
const DogIcon = ({ size = 28, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 5.172C10 3.782 8.423 2.679 6.5 3c-2 .336-3.5 2.112-3.5 4-.085 2.053.416 3.461 1.5 4.5s1 3.5 0 4.5"/>
    <path d="m10 5.172 2 3.792c0 .01 2.36 5.036 2 6.036-1 2-4 2-5 0s-.5-4 0-5"/>
    <path d="M16.5 12s.5 2 3 3c0 3-3 5-6 4.5s-3-3.5-3-3.5"/>
    <path d="M3 12s.5-1 1-2"/><path d="M5 3.5s.5-1 2-1c.83 0 1.5.5 1.5.5"/>
  </svg>
);
const EditIcon = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);
const SaveIcon = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
    <polyline points="17 21 17 13 7 13 7 21"/>
    <polyline points="7 3 7 8 15 8"/>
  </svg>
);
const HistoryIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <polyline points="12 8 12 12 14 14"/>
    <path d="M3.05 11a9 9 0 1 0 .5-4.5L1 4"/>
    <polyline points="1 4 1 8 5 8"/>
  </svg>
);
const AlertIcon = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
    strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
    <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
  </svg>
);
const MaleIcon = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="10" cy="14" r="5"/><path d="M21 3l-6 6m0-6h6v6"/>
  </svg>
);
const FemaleIcon = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="6"/><line x1="12" y1="14" x2="12" y2="22"/><line x1="9" y1="19" x2="15" y2="19"/>
  </svg>
);
const CameraIcon = ({ size = 24, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
    <circle cx="12" cy="13" r="4"/>
  </svg>
);

// ─── Compress Image Helper ──────────────────────────────────────────────────────
const compressImage = (file, maxPx = 500, quality = 0.72) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const ratio  = Math.min(maxPx / img.width, maxPx / img.height, 1);
        const canvas = document.createElement("canvas");
        canvas.width  = img.width  * ratio;
        canvas.height = img.height * ratio;
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });

// ─── Age helpers ──────────────────────────────────────────────────────────────
const getRealAgeYears = (birthday) => {
  if (!birthday) return null;
  const diff = Date.now() - new Date(birthday).getTime();
  return diff / (1000 * 60 * 60 * 24 * 365.25);
};

const toDogAge = (realYears) => {
  if (realYears === null) return null;
  if (realYears <= 0) return 0;
  if (realYears <= 1) return Math.round(realYears * 15);
  if (realYears <= 2) return Math.round(15 + (realYears - 1) * 9);
  return Math.round(24 + (realYears - 2) * 5);
};

const toCatAge = (realYears) => {
  if (realYears === null) return null;
  if (realYears <= 0) return 0;
  if (realYears <= 1) return Math.round(realYears * 15);
  if (realYears <= 2) return Math.round(15 + (realYears - 1) * 9);
  return Math.round(24 + (realYears - 2) * 4);
};

const formatRealAge = (realYears) => {
  if (realYears === null) return null;
  const totalMonths = Math.round(realYears * 12);
  if (totalMonths < 12) return `${totalMonths} month${totalMonths !== 1 ? "s" : ""}`;
  const yrs = Math.floor(realYears);
  const mos = Math.round((realYears - yrs) * 12);
  return mos > 0 ? `${yrs} yr${yrs !== 1 ? "s" : ""} ${mos} mo` : `${yrs} yr${yrs !== 1 ? "s" : ""}`;
};

const getApptScheduleDetails = (apt) => {
  if (!apt) return { dateStr: "N/A", timeStr: "Not specified" };
  const firstPet = apt.pets?.[0];
  const dateObj = firstPet?.grooming?.date || firstPet?.hotel?.checkInDate || apt.appointmentDate || apt.createdAt;
  const time = firstPet?.grooming?.time || firstPet?.hotel?.checkInTime || apt.appointmentTime || "";
  const dateStr = dateObj ? new Date(dateObj).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" }) : "N/A";
  return { dateStr, timeStr: time || "Not specified" };
};

// ─── Age Card ─────────────────────────────────────────────────────────────────
const AgeCard = ({ pet }) => {
  const realYears = getRealAgeYears(pet.birthday);
  if (realYears === null) return null;
  const petAge  = pet.petType === "cat" ? toCatAge(realYears) : toDogAge(realYears);
  const realStr = formatRealAge(realYears);
  const PetIcon = pet.petType === "cat" ? CatIcon : DogIcon;
  const label   = pet.petType === "cat" ? "Cat Age" : "Dog Age";
  return (
    <div className="mt-3 rounded-2xl bg-gradient-to-r from-amber-50 to-orange-50 border-2 border-amber-100 p-4 flex items-center gap-4">
      <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-100 to-orange-100 flex items-center justify-center">
        <PetIcon size={26} color="#d97706" />
      </div>
      <div className="flex-1">
        <p className="text-[10px] font-black uppercase tracking-widest text-amber-500 mb-0.5">Age</p>
        <p className="text-lg font-black text-gray-800">
          {realStr} old
        </p>
        <p className="text-xs text-amber-700 font-bold">
          ≈ {petAge} in {label.toLowerCase()} years
        </p>
      </div>
      <div className="text-right">
        <p className="text-3xl font-black text-amber-500">{petAge}</p>
        <p className="text-[10px] font-bold text-amber-400 uppercase">{label}</p>
      </div>
    </div>
  );
};

const STATUS_STYLES = {
  pending:   { bg: "bg-amber-100",   text: "text-amber-700",   label: "Pending"   },
  confirmed: { bg: "bg-blue-100",    text: "text-blue-700",    label: "Confirmed" },
  ongoing:   { bg: "bg-indigo-100",  text: "text-indigo-700",  label: "On Going"  },
  completed: { bg: "bg-emerald-100", text: "text-emerald-700", label: "Completed" },
  rejected:  { bg: "bg-red-100",     text: "text-red-700",     label: "Rejected"  },
  cancelled: { bg: "bg-red-100",     text: "text-red-700",     label: "Cancelled" },
  cancel_requested: { bg: "bg-orange-100", text: "text-orange-700", label: "Cancel Req." },
  reschedule_requested: { bg: "bg-orange-100", text: "text-orange-700", label: "Reschedule Req." },
};

// ─── Loyalty Card ─────────────────────────────────────────────────────────────
const LoyaltyCard = ({ pet }) => {
  const count = pet.visitCount || 0;
  
  let rewardMessage = "Start earning rewards!";
  if (count >= 10) rewardMessage = "You've earned a Free Grooming!";
  else if (count >= 5) rewardMessage = `20% Off Unlocked! Next: Free Grooming`;
  else if (count > 0) rewardMessage = `${5 - count} more visits for 20% Off!`;

  return (
    <div className="mt-4 rounded-2xl overflow-hidden border-2 border-dashed border-purple-200 bg-gradient-to-br from-purple-50 to-pink-50">
      <div className="flex items-center justify-between px-4 pt-4 pb-2">
        <div>
          <p className="text-[10px] font-black uppercase tracking-widest text-purple-400">Loyalty Card</p>
          <p className="text-sm font-black text-purple-700">{pet.petName}</p>
        </div>
        <div className="w-8 h-8 flex items-center justify-center">
          <PawIcon size={22} color="#7C3AED" />
        </div>
      </div>
      <div className="px-4 pb-4">
        <div className="grid grid-cols-5 gap-2 mt-2">
          {[...Array(10)].map((_, i) => {
            const isAchieved = i < count;
            const isFifth = i === 4;
            const isTenth = i === 9;
            
            let content = isAchieved ? <PawIcon size={13} color="white" /> : "○";
            if (!isAchieved) {
              if (isFifth) content = <span className="text-xs font-black">20%</span>;
              if (isTenth) content = <span className="text-xs font-black">Free</span>;
            }

            return (
              <div
                key={i}
                className={`w-full aspect-square rounded-xl flex items-center justify-center text-lg border-2 ${
                  isAchieved
                    ? "bg-purple-500 border-purple-500 text-white shadow-sm"
                    : isFifth || isTenth 
                      ? "bg-pink-100 border-pink-300 text-pink-500"
                      : "bg-white border-purple-100 text-purple-200"
                }`}
              >
                {content}
              </div>
            );
          })}
        </div>
        <div className="text-center mt-3">
          <p className="text-[10px] text-purple-500 font-bold uppercase tracking-wider">
            {count}/10 Visits
          </p>
          <p className="text-xs text-purple-700 font-bold mt-0.5">
            {rewardMessage}
          </p>
        </div>
      </div>
    </div>
  );
};

// ─── Editable Pet Card ────────────────────────────────────────────────────────
const PetCard = ({ pet, userToken, userId, onSaved, onViewHistory, onZoomImage }) => {
  const [expanded, setExpanded]   = useState(false);
  const [editing,  setEditing]    = useState(false);
  const [saving,   setSaving]     = useState(false);
  const [saveErr,  setSaveErr]    = useState(null);
  const [form, setForm] = useState({
    petName:       pet.petName       || "",
    breed:         pet.breed         || "",
    birthday:      pet.birthday ? new Date(pet.birthday).toISOString().split("T")[0] : "",
    gender:        pet.gender        || "unknown",
    colorMarkings: pet.colorMarkings || "",
    photoUrl:      pet.photoUrl      || "",
    behaviorNotes: pet.behaviorNotes || "",
    health: {
      isVaccinated:        pet.health?.isVaccinated        ?? false,
      lastVaccinationDate: pet.health?.lastVaccinationDate
        ? new Date(pet.health.lastVaccinationDate).toISOString().split("T")[0]
        : "",
      medicalConditions:   pet.health?.medicalConditions   || "",
      medication:          pet.health?.medication          || "",
    },
  });

  const handleChange = (field, value) =>
    setForm((f) => ({ ...f, [field]: value }));

  const handleHealthChange = (field, value) =>
    setForm((f) => ({ ...f, health: { ...f.health, [field]: value } }));

  const handleSave = async () => {
    if (!form.petName.trim()) {
      setSaveErr("Pet name is required.");
      return;
    }
    if (!form.birthday) {
      setSaveErr("Birthdate is required.");
      return;
    }
    setSaving(true);
    setSaveErr(null);
    try {
      const config = { headers: { Authorization: `Bearer ${userToken}` } };
      await axios.put(
        `/api/auth/me/pets/${pet._id}`,
        {
          petName:       form.petName,
          petType:       form.petType || pet.petType,
          breed:         form.breed,
          birthday:      form.birthday || null,
          gender:        form.gender,
          colorMarkings: form.colorMarkings,
          photoUrl:      form.photoUrl,
          behaviorNotes: form.behaviorNotes,
          health:        form.health,
        },
        config
      );
      setEditing(false);
      if (onSaved) onSaved();
    } catch (err) {
      setSaveErr(err.response?.data?.message || "Failed to save. Try again.");
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setForm({
      petName:       pet.petName       || "",
      breed:         pet.breed         || "",
      birthday:      pet.birthday ? new Date(pet.birthday).toISOString().split("T")[0] : "",
      gender:        pet.gender        || "unknown",
      colorMarkings: pet.colorMarkings || "",
      photoUrl:      pet.photoUrl      || "",
      behaviorNotes: pet.behaviorNotes || "",
      health: {
        isVaccinated:        pet.health?.isVaccinated        ?? false,
        lastVaccinationDate: pet.health?.lastVaccinationDate
          ? new Date(pet.health.lastVaccinationDate).toISOString().split("T")[0]
          : "",
        medicalConditions:   pet.health?.medicalConditions   || "",
        medication:          pet.health?.medication          || "",
      },
    });
    setEditing(false);
    setSaveErr(null);
  };

  const inputCls =
    "w-full px-4 py-2.5 rounded-xl border-2 border-purple-100 bg-white text-gray-800 text-sm font-medium focus:outline-none focus:border-purple-400 transition-all";

  return (
    <div className="bg-white/70 backdrop-blur rounded-2xl border-2 border-purple-100 overflow-hidden hover:shadow-lg transition-all">
      {/* Header row */}
      <div className="p-5 flex items-center justify-between">
        <button
          onClick={() => setExpanded(!expanded)}
          className="flex items-center space-x-4 text-left flex-1 hover:opacity-80 transition-opacity"
        >
          <div className="w-12 h-12 bg-gradient-to-br from-purple-400 to-pink-400 rounded-2xl flex items-center justify-center shadow-md">
            {pet.petType === "cat" ? <CatIcon size={24} color="white" /> : <DogIcon size={24} color="white" />}
          </div>
          <div>
            <p className="font-black text-gray-800 text-lg">{pet.petName}</p>
            <p className="text-sm text-gray-500 capitalize">
              {pet.petType} · {pet.breed || "Mixed"}
            </p>
          </div>
        </button>

        <div className="flex items-center space-x-3">
          {pet.visitCount !== undefined && (
            <span className="text-xs font-bold bg-purple-100 text-purple-700 px-3 py-1 rounded-full">
              {pet.visitCount} visit{pet.visitCount !== 1 ? "s" : ""}
            </span>
          )}
          <button
            onClick={() => {
              setEditing(!editing);
              setExpanded(true);
              setSaveErr(null);
            }}
            className={`px-4 py-1.5 rounded-xl text-xs font-bold border-2 transition-all ${
              editing
                ? "bg-purple-600 text-white border-purple-600"
                : "bg-white text-purple-600 border-purple-200 hover:bg-purple-50"
            }`}
          >
            {editing ? "Editing…" : <span className="flex items-center gap-1"><EditIcon size={13} color="currentColor" /> Edit</span>}
          </button>
          <svg
            onClick={() => setExpanded(!expanded)}
            className={`w-5 h-5 text-purple-400 transition-transform cursor-pointer ${expanded ? "rotate-180" : ""}`}
            fill="none" stroke="currentColor" viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {/* Expanded content */}
      {expanded && (
        <div className="px-5 pb-5 space-y-4 border-t border-purple-50 pt-4">
          {editing ? (
            /* ── Edit Form ── */
            <div className="space-y-4">
              <p className="text-xs font-black uppercase tracking-widest text-purple-400 mb-2">Edit Pet Info</p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {/* Pet Name */}
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-1">Pet Name</label>
                  <input
                    className={inputCls}
                    value={form.petName}
                    onChange={(e) => handleChange("petName", e.target.value)}
                    placeholder="Pet name"
                  />
                </div>
                {/* Breed */}
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-1">Breed</label>
                  <input
                    className={inputCls}
                    value={form.breed}
                    onChange={(e) => handleChange("breed", e.target.value)}
                    placeholder="e.g. Shih Tzu, Persian"
                  />
                </div>
                {/* Birthday */}
                <div className="sm:col-span-2">
                  <label className="block text-xs font-bold text-gray-500 mb-1 flex items-center gap-1"><CalendarIcon size={13} color="#6B7280" /> Birthdate *</label>
                  <input
                    type="date"
                    className={inputCls}
                    value={form.birthday}
                    max={getLocalDateString()}
                    onChange={(e) => handleChange("birthday", e.target.value)}
                    required
                  />
                  {form.birthday && (() => {
                    const realYears = getRealAgeYears(form.birthday);
                    const petAge    = pet.petType === "cat" ? toCatAge(realYears) : toDogAge(realYears);
                    const realStr   = formatRealAge(realYears);
                    return (
                      <p className="mt-1.5 text-xs text-amber-600 font-bold flex items-center gap-1">
                        <PawIcon size={11} color="#d97706" /> {realStr} old ≈ <span className="text-amber-700">{petAge} in {pet.petType} years</span>
                      </p>
                    );
                  })()}
                  {form.birthday && !isPetEligibleForGrooming(form.birthday, getLocalDateString()) && (
                    <div className="mt-2 p-2.5 bg-amber-50 border border-amber-200 rounded-xl text-amber-800 text-xs flex items-start gap-1.5">
                      <span className="text-sm">⚠️</span>
                      <div>
                        <span className="font-bold">Notice:</span> Furpect Tails is not accepting pets under 6 months old for grooming services.
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Behavior Notes */}
              <div>
                <label className="block text-xs font-bold text-gray-500 mb-1">Behavior Notes</label>
                <textarea
                  className={`${inputCls} resize-none`}
                  rows={2}
                  value={form.behaviorNotes}
                  onChange={(e) => handleChange("behaviorNotes", e.target.value)}
                  placeholder="Any special behavior or temperament notes…"
                />
              </div>

              {/* Gender + Color/Markings */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-1 flex items-center gap-1">
                    <MaleIcon size={13} color="#6B7280" /><FemaleIcon size={13} color="#6B7280" /> Gender
                  </label>
                  <select
                    className={inputCls}
                    value={form.gender}
                    onChange={(e) => handleChange("gender", e.target.value)}
                  >
                    <option value="male">Male ♂</option>
                    <option value="female">Female ♀</option>
                    <option value="unknown">Unknown</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-1">Color / Markings</label>
                  <input
                    className={inputCls}
                    value={form.colorMarkings}
                    onChange={(e) => handleChange("colorMarkings", e.target.value)}
                    placeholder="e.g. Golden with white patches"
                  />
                </div>
              </div>

              {/* Photo Upload */}
              <div>
                <label className="block text-xs font-bold text-gray-500 mb-2 flex items-center gap-1"><CameraIcon size={13} color="#6B7280" /> Pet Photo</label>
                <div className="flex items-start gap-4">
                  {form.photoUrl && (
                    <div className="relative flex-shrink-0">
                      <img
                        src={form.photoUrl}
                        alt="Pet preview"
                        className="w-20 h-20 object-cover rounded-2xl border-2 border-purple-100 shadow"
                      />
                      <button
                        type="button"
                        onClick={() => handleChange("photoUrl", "")}
                        className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white rounded-full text-xs font-black flex items-center justify-center hover:bg-red-600"
                      >
                        ×
                      </button>
                    </div>
                  )}
                  <label className="flex-1 flex flex-col items-center justify-center border-2 border-dashed border-purple-200 rounded-2xl p-4 cursor-pointer hover:border-purple-400 hover:bg-purple-50/50 transition-all">
                    <CameraIcon size={22} color="#a855f7" />
                    <span className="text-xs font-bold text-purple-500">{form.photoUrl ? "Change photo" : "Upload photo"}</span>
                    <span className="text-[10px] text-gray-400 mt-0.5">JPG, PNG • auto-compressed</span>
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={async (e) => {
                        const file = e.target.files?.[0];
                        if (!file) return;
                        const compressed = await compressImage(file);
                        handleChange("photoUrl", compressed);
                      }}
                    />
                  </label>
                </div>
              </div>

              {/* Health Section */}
              <div className="bg-purple-50/60 rounded-2xl p-4 space-y-3">
                <div className="flex items-center justify-between">
                  <p className="text-xs font-black uppercase tracking-widest text-purple-500">Health Information</p>
                  <span className="text-[9px] font-bold text-rose-600 bg-rose-50 px-2 py-0.5 rounded-full border border-rose-200">Vaccine Required</span>
                </div>
                <div className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    id={`vaccinated-${pet.petName}`}
                    checked={form.health.isVaccinated}
                    onChange={(e) => handleHealthChange("isVaccinated", e.target.checked)}
                    className="w-4 h-4 accent-purple-600 cursor-pointer"
                  />
                  <label htmlFor={`vaccinated-${pet.petName}`} className="text-sm font-bold text-gray-700 cursor-pointer">
                    Vaccinated (Anti-Rabies / Up-to-date)
                  </label>
                </div>
                {!form.health.isVaccinated && (
                  <p className="text-[11px] text-amber-800 bg-amber-50 border border-amber-200 p-2 rounded-xl">
                    ⚠️ <strong>Store Policy:</strong> Pets without up-to-date vaccination will not be accepted in the store.
                  </p>
                )}
                {form.health.isVaccinated && (
                  <div>
                    <label className="block text-xs font-bold text-gray-500 mb-1">Last Vaccination Date</label>
                    <input
                      type="date"
                      className={inputCls}
                      value={form.health.lastVaccinationDate}
                      onChange={(e) => handleHealthChange("lastVaccinationDate", e.target.value)}
                    />
                  </div>
                )}
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-1">Medical Conditions</label>
                  <input
                    className={inputCls}
                    value={form.health.medicalConditions}
                    onChange={(e) => handleHealthChange("medicalConditions", e.target.value)}
                    placeholder="Any known conditions…"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-1">Current Medication</label>
                  <input
                    className={inputCls}
                    value={form.health.medication}
                    onChange={(e) => handleHealthChange("medication", e.target.value)}
                    placeholder="e.g. Apoquel 16mg daily"
                  />
                </div>
              </div>

              {saveErr && (
                <p className="text-xs text-red-600 font-bold bg-red-50 px-4 py-2 rounded-xl flex items-center gap-1.5"><AlertIcon size={13} color="#dc2626" /> {saveErr}</p>
              )}

              <div className="flex gap-3">
                <button
                  onClick={handleSave}
                  disabled={saving}
                  className="flex-1 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-2xl shadow-lg hover:scale-[1.02] transition-all disabled:opacity-60 disabled:cursor-not-allowed text-sm"
                >
                  {saving ? "Saving…" : <span className="flex items-center gap-2"><SaveIcon size={14} color="white" /> Save Changes</span>}
                </button>
                <button
                  onClick={handleCancel}
                  disabled={saving}
                  className="px-6 py-3 bg-white border-2 border-gray-200 text-gray-600 font-bold rounded-2xl hover:bg-gray-50 transition-all text-sm"
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            /* ── View Mode ── */
            <div className="space-y-4">
              <div className="flex flex-col md:flex-row gap-4">
                {/* Pet Photo */}
                {pet.photoUrl && (
                  <div 
                    onClick={() => onZoomImage && onZoomImage(pet.photoUrl)}
                    className="w-full md:w-1/2 cursor-zoom-in group relative rounded-2xl overflow-hidden border-2 border-purple-100 shadow-md"
                  >
                    <img
                      src={pet.photoUrl}
                      alt={pet.petName}
                      className="w-full h-full max-h-52 object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                      <span className="text-white bg-black/60 px-3 py-1 rounded-full text-xs font-bold font-sans">🔍 View Photo</span>
                    </div>
                  </div>
                )}
                
                {/* QR Code for Admin Scanner */}
                <div className={`flex flex-col items-center justify-center p-4 bg-white border-2 border-dashed border-purple-200 rounded-2xl shadow-sm ${pet.photoUrl ? 'w-full md:w-1/2' : 'w-full'}`}>
                  <div className="p-2 bg-white rounded-xl shadow-sm border border-gray-100">
                    <QRCodeSVG
                      value={`${window.location.origin}/pet/${userId}/${pet._id}`}
                      size={120}
                      level={"M"}
                      includeMargin={false}
                    />
                  </div>
                  <p className="text-xs font-bold text-purple-600 mt-3 text-center">Scan at the clinic</p>
                  <p className="text-[10px] text-gray-500 mt-0.5 uppercase tracking-widest font-semibold">Pet ID Digital Pass</p>
                  <p className="text-[9px] text-purple-500 font-medium mt-1">🛡️ For Staff / Admin Scanner</p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3 text-sm">
                <div className="bg-purple-50 rounded-xl p-3">
                  <p className="text-xs font-bold text-purple-400 uppercase mb-1">Breed</p>
                  <p className="font-bold text-gray-700">{pet.breed || "—"}</p>
                </div>
                <div className="bg-purple-50 rounded-xl p-3">
                  <p className="text-xs font-bold text-purple-400 uppercase mb-1">Type</p>
                  <p className="font-bold text-gray-700 capitalize">{pet.petType}</p>
                </div>
                <div className="bg-purple-50 rounded-xl p-3">
                  <p className="text-xs font-bold text-purple-400 uppercase mb-1">Gender</p>
                  <p className="font-bold text-gray-700 capitalize">
                    {pet.gender === "male" ? (
                      <span className="flex items-center gap-1"><MaleIcon size={13} color="currentColor" /> Male</span>
                    ) : pet.gender === "female" ? (
                      <span className="flex items-center gap-1"><FemaleIcon size={13} color="currentColor" /> Female</span>
                    ) : "Unknown"}
                  </p>
                </div>
                {pet.colorMarkings && (
                  <div className="bg-purple-50 rounded-xl p-3">
                    <p className="text-xs font-bold text-purple-400 uppercase mb-1">Color / Markings</p>
                    <p className="font-bold text-gray-700">{pet.colorMarkings}</p>
                  </div>
                )}
              </div>
              {pet.behaviorNotes && (
                <div className="bg-amber-50 rounded-xl p-3 text-sm">
                  <p className="text-xs font-bold text-amber-500 uppercase mb-1">Behavior Notes</p>
                  <p className="text-gray-700">{pet.behaviorNotes}</p>
                </div>
              )}
              {pet.health && (
                <div className="bg-emerald-50 rounded-xl p-3 text-sm space-y-1">
                  <p className="text-xs font-bold text-emerald-600 uppercase mb-1">Health</p>
                  <p className="text-gray-700">
                    Vaccinated: <span className="font-bold flex items-center gap-1 inline-flex">{pet.health.isVaccinated ? <><CheckIcon size={13} color="#059669" strokeWidth={2.5}/> Yes</> : "No"}</span>
                  </p>
                  {pet.health.medicalConditions && (
                    <p className="text-gray-700">Conditions: <span className="font-bold">{pet.health.medicalConditions}</span></p>
                  )}
                  {pet.health.medication && (
                    <p className="text-gray-700">Medication: <span className="font-bold">{pet.health.medication}</span></p>
                  )}
                </div>
              )}
              <AgeCard pet={pet} />
              <LoyaltyCard pet={pet} />
                <button 
                  onClick={() => onViewHistory && onViewHistory(pet)} 
                  className="w-full mt-4 py-3 bg-purple-50 text-purple-600 font-bold rounded-2xl hover:bg-purple-100 transition-colors flex items-center justify-center gap-2 border border-purple-100 shadow-sm"
                >
                  <HistoryIcon size={16} color="#7C3AED" /> View History
                </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const CustomerDashboard = ({ user = {}, setUser, setActiveTab, handleLogout }) => {
  const [appointments, setAppointments] = useState([]);
  const [myPets,       setMyPets]       = useState(user?.pets || []);
  const [loading,      setLoading]      = useState(true);
  const [error,        setError]        = useState(null);
  const [activeSection, setActiveSection] = useState("dashboard");
  const [bookingFilter, setBookingFilter] = useState("all"); // "all", "active", "history"
  // eslint-disable-next-line no-unused-vars
  const [avatarMenuOpen, setAvatarMenuOpen] = useState(false);
  const [petHistoryModal, setPetHistoryModal] = useState(null);
  const [zoomImage, setZoomImage] = useState(null);
  const [checkInQrModal, setCheckInQrModal] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const [actionModal, setActionModal] = useState({ isOpen: false, apt: null, type: null });
  const [actionForm, setActionForm] = useState({ reason: "", customReason: "", date: "", time: "" });
  const [actionError, setActionError] = useState(null);

  const [feedbackModal, setFeedbackModal] = useState({ isOpen: false, apt: null, rating: 5, feedback: "" });
  const [feedbackSaving, setFeedbackSaving] = useState(false);
  const [feedbackErr, setFeedbackErr] = useState(null);

  const handleFeedbackSubmit = async () => {
    const { apt, rating, feedback } = feedbackModal;
    setFeedbackSaving(true);
    setFeedbackErr(null);
    try {
      await axios.post(`/api/appointments/${apt._id}/rate`, { rating, feedback }, { headers: { Authorization: `Bearer ${user?.token || ""}` } });
      fetchData();
      setFeedbackModal({ isOpen: false, apt: null, rating: 5, feedback: "" });
    } catch (err) {
      setFeedbackErr(err.response?.data?.message || "Failed to submit feedback.");
    } finally {
      setFeedbackSaving(false);
    }
  };

  const handleCustomerActionSubmit = async () => {
    const { apt, type } = actionModal;
    const finalReason = actionForm.reason === "Others" ? actionForm.customReason : actionForm.reason;

    if (!actionForm.reason) {
      setActionError("Please select a reason.");
      return;
    }
    if (actionForm.reason === "Others" && !actionForm.customReason.trim()) {
      setActionError("Please specify your reason in the text field.");
      return;
    }
    setActionError(null);

    try {
      if (type === "cancel") {
        await axios.post(`/api/appointments/${apt._id}/request-cancel`, { reason: finalReason }, { headers: { Authorization: `Bearer ${user?.token || ""}` } });
      } else if (type === "reschedule") {
        if (!actionForm.date) {
          setActionError("Please select a new requested date.");
          return;
        }
        const todayStr = getLocalDateString();
        if (actionForm.date < todayStr) {
          setActionError("Reschedule date cannot be in the past. Please choose today or a future date.");
          return;
        }
        const day = new Date(actionForm.date + "T00:00:00").getDay();
        if (day === 1) {
          setActionError("The store is closed on Mondays. Please select another date.");
          return;
        }

        // Validate 6-month age requirement for grooming
        for (const p of apt.pets || []) {
          if (p.grooming?.date || p.grooming?.service) {
            let bday = p.birthday;
            if (!bday && (user?.pets || []).length > 0) {
              const matchedPet = (user.pets || []).find(up => up._id === (p.pet || p._id));
              if (matchedPet) bday = matchedPet.birthday;
            }
            if (bday && !isPetEligibleForGrooming(bday, actionForm.date)) {
              const minD = getPetMinGroomingDate(bday);
              const minDStr = minD ? minD.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";
              setActionError(`Furpect Tails is not accepting pets under 6 months old for grooming. ${p.petName || "Pet"} must be at least 6 months old (eligible starting ${minDStr}).`);
              return;
            }
          }
        }
        if (!actionForm.time) {
          setActionError("Please select a new requested time.");
          return;
        }
        if (isTimeSlotPast(actionForm.date, actionForm.time)) {
          setActionError("Requested reschedule time has already passed. Please select an upcoming time.");
          return;
        }
        await axios.post(`/api/appointments/${apt._id}/request-reschedule`, { reason: finalReason, date: actionForm.date, time: actionForm.time }, { headers: { Authorization: `Bearer ${user?.token || ""}` } });
      }
      fetchData();
      setActionModal({ isOpen: false, apt: null, type: null });
      setActionError(null);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to submit request.");
    }
  };

  useEffect(() => {
    if (actionModal.isOpen) {
      setActionForm({ reason: "", customReason: "", date: "", time: "" });
      setActionError(null);
    }
  }, [actionModal.isOpen, actionModal.type]);

  const handleConfirmation = async (apt, response) => {
    try {
      await axios.post(`/api/appointments/${apt._id}/confirm`, { response }, { headers: { Authorization: `Bearer ${user?.token || ""}` } });
      fetchData();
    } catch (err) {
      alert("Failed to submit confirmation.");
    }
  };

  const handlePickupConfirmation = async (apt) => {
    try {
      await axios.post(`/api/appointments/${apt._id}/pickup`, {}, { headers: { Authorization: `Bearer ${user?.token || ""}` } });
      fetchData();
    } catch (err) {
      alert("Failed to confirm pickup.");
    }
  };

  const [appointmentDetailsModal, setAppointmentDetailsModal] = useState(null);

  const [addingPet, setAddingPet] = useState(false);
  const [newPetForm, setNewPetForm] = useState({ 
    petName: "", petType: "dog", breed: "", customBreed: "", gender: "unknown", birthday: "", colorMarkings: "", photoUrl: "",
    health: { isVaccinated: false, lastVaccinationDate: "", medicalConditions: "", medication: "" }
  });
  const [addingPetLoading, setAddingPetLoading] = useState(false);
  const [addingPetError, setAddingPetError] = useState(null);

  const handleAddPet = async () => {
    if (addingPetLoading) return;
    if (!newPetForm.petName.trim()) {
      setAddingPetError("Pet name is required");
      return;
    }
    if (!newPetForm.birthday) {
      setAddingPetError("Birthdate is required");
      return;
    }
    setAddingPetLoading(true);
    setAddingPetError(null);
    try {
      const payload = {
        ...newPetForm,
        breed: newPetForm.breed === "Other" ? newPetForm.customBreed : newPetForm.breed
      };
      const res = await axios.post("/api/auth/me/pets", payload, {
        headers: { Authorization: `Bearer ${user?.token || ""}` }
      });
      const updatedUser = { ...user, pets: res.data.data };
      setUser(updatedUser);
      localStorage.setItem("user", JSON.stringify(updatedUser));
      setAddingPet(false);
      setNewPetForm({ 
        petName: "", petType: "dog", breed: "", customBreed: "", gender: "unknown", birthday: "", colorMarkings: "", photoUrl: "",
        health: { isVaccinated: false, lastVaccinationDate: "", medicalConditions: "", medication: "" }
      });
      fetchData(); // Refresh enriched pets
    } catch (err) {
      setAddingPetError(err.response?.data?.message || "Failed to add pet.");
    } finally {
      setAddingPetLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const config = { headers: { Authorization: `Bearer ${user?.token || ""}` } };
      const [appRes, meRes] = await Promise.all([
        axios.get("/api/appointments", config),
        axios.get("/api/auth/me", config)
      ]);
      if (appRes.data.success) {
        const sorted = appRes.data.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setAppointments(sorted);
      }
      if (appRes.data.success) {
        const allAppts = appRes.data.data || [];
        // Use pets from /me if available, otherwise fall back to user context pets
        let userPets = (meRes.data?.success && (meRes.data.pets || []).length > 0)
          ? meRes.data.pets
          : (user?.pets || []);

        // Fallback: If user has no pets in profile yet, extract unique pets from their booked appointments
        if (userPets.length === 0 && allAppts.length > 0) {
          const extractedMap = new Map();
          allAppts.forEach(appt => {
            (appt.pets || []).forEach(p => {
              const nameKey = (p.petName || "").trim().toLowerCase();
              if (nameKey && !extractedMap.has(nameKey)) {
                extractedMap.set(nameKey, {
                  _id: (p.pet && (typeof p.pet === "object" ? p.pet._id : p.pet)) || `pet-${nameKey}`,
                  petName: p.petName,
                  petType: p.petType || "dog",
                  breed: p.breed || "Mixed Breed",
                  photoUrl: p.photoUrl || "",
                });
              }
            });
          });
          userPets = Array.from(extractedMap.values());
        }

        // Deduplicate pets so multiple pet details with the same name are never shown
        const seenPetKeys = new Set();
        const deduplicatedPets = [];
        userPets.forEach(p => {
          if (!p) return;
          const key = `${p.petName?.trim().toLowerCase()}_${p.petType?.trim().toLowerCase()}`;
          if (seenPetKeys.has(key)) return;
          seenPetKeys.add(key);
          deduplicatedPets.push(p);
        });

        const enrichedPets = deduplicatedPets.map(pet => {
          let count = 0;
          allAppts.forEach(appt => {
            if (appt.status === "completed") {
              (appt.pets || []).forEach(p => {
                // Match by ObjectId reference first, then fall back to name
                const petIdMatch = p.pet && pet._id && (
                  (typeof p.pet === "string" ? p.pet : p.pet?._id?.toString?.() || p.pet?.toString?.()) === pet._id.toString()
                );
                const nameTypeMatch = p.petName?.trim().toLowerCase() === pet.petName?.trim().toLowerCase();
                if (petIdMatch || nameTypeMatch) count++;
              });
            }
          });
          return { ...pet, visitCount: count };
        });
        setMyPets(enrichedPets);
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to load dashboard data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (user?.token) fetchData(); }, [user?.token]); // eslint-disable-line

  // Active statuses: ongoing, reschedule_requested, cancel_requested, confirmed, pending
  const ACTIVE_STATUS_LIST = ["ongoing", "reschedule_requested", "cancel_requested", "confirmed", "pending"];
  const activeAppointments = appointments.filter(a => ACTIVE_STATUS_LIST.includes(a.status));
  const pastAppointments = appointments.filter(a => !ACTIVE_STATUS_LIST.includes(a.status));
  // eslint-disable-next-line no-unused-vars
  const recentHistory = pastAppointments.slice(0, 3);

  return (
    <div className="min-h-screen bg-[#f8f6f4] font-sans flex flex-col md:flex-row">

      {/* Mobile Top Header */}
      <div className="md:hidden flex items-center justify-between bg-gradient-to-r from-purple-700 to-pink-600 text-white px-5 py-4 sticky top-0 z-40 shadow-md">
        <div className="flex items-center gap-3">
          <img src="/furpect-tails-logo.png" alt="Furpect Tails" className="w-8 h-8 object-contain drop-shadow" />
          <span className="font-black text-white text-base tracking-tight">Furpect Tails</span>
        </div>
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="p-1 rounded-lg hover:bg-white/20 text-white transition-colors"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Mobile Sidebar Backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/45 backdrop-blur-sm z-[45] md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* ── LEFT SIDEBAR ── */}
      <aside className={`fixed md:sticky top-0 left-0 h-screen w-64 flex flex-col z-50 transition-transform duration-300 md:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ background: "linear-gradient(160deg, #3b1f6b 0%, #6d2b8b 50%, #9d2f5e 100%)" }}
      >
        {/* Brand */}
        <div className="p-6 border-b border-white/10 flex items-center gap-3">
          <img
            src="/furpect-tails-logo.png"
            alt="Furpect Tails Logo"
            className="w-11 h-11 object-contain drop-shadow-md"
          />
          <div>
            <h1 className="font-black text-white text-base tracking-tight leading-tight">Furpect Tails</h1>
            <p className="text-[9px] text-purple-200 font-bold uppercase tracking-widest mt-0.5">Customer Portal</p>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-4 py-6 space-y-1.5 overflow-y-auto">
          {[
            { id: "dashboard", label: "Dashboard",              Icon: FileTextIcon },
            { id: "pets",      label: "My Pets & Rewards",      Icon: PawIcon      },
            { id: "bookings",  label: "Appointments & History", Icon: CalendarIcon },
          ].map(item => (
            <button
              key={item.id}
              onClick={() => { setActiveSection(item.id); setSidebarOpen(false); }}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold transition-all ${
                activeSection === item.id
                  ? "bg-white/25 text-white shadow-md scale-[1.02]"
                  : "text-purple-100 hover:text-white hover:bg-white/15 hover:translate-x-1"
              }`}
            >
              <item.Icon size={18} color="currentColor" />
              <span>{item.label}</span>
            </button>
          ))}

          <div className="pt-4 mt-4 border-t border-white/10">
            <button
              onClick={() => { setSidebarOpen(false); setActiveTab("booking"); }}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold text-purple-100 hover:text-white hover:bg-white/15 transition-all"
            >
              <ScissorsIcon size={18} color="currentColor" />
              <span>Book Appointment</span>
            </button>
          </div>
        </nav>

        {/* User Card & Logout */}
        <div className="p-4 border-t border-white/10" style={{ background: "rgba(0,0,0,0.15)" }}>
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-white shadow-inner text-lg" style={{ background: "rgba(255,255,255,0.2)" }}>
              {user?.name ? user.name.charAt(0).toUpperCase() : "U"}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-bold text-white truncate leading-tight">{user?.name || "Customer"}</p>
              <p className="text-[10px] text-purple-200 font-bold uppercase tracking-wider">Customer</p>
            </div>
          </div>
          <button
            onClick={() => setShowLogoutConfirm(true)}
            className="w-full py-2.5 rounded-xl text-xs font-bold transition-colors border border-red-400/30 text-red-300 hover:text-red-200 hover:bg-red-500/20"
          >
            Log Out
          </button>
        </div>
      </aside>

      {/* ── RIGHT CONTENT CONTAINER ── */}
      <div className="flex-1 min-h-screen flex flex-col min-w-0">

        {/* Top Page Header */}
        <header className="bg-white border-b border-gray-200 h-20 px-4 md:px-8 flex items-center justify-between shrink-0 shadow-sm">
          <div>
            <h2 className="text-lg md:text-2xl font-black text-gray-800">
              {activeSection === "dashboard" ? `Welcome, ${(user?.name || "Customer").split(" ")[0]}!` : activeSection === "pets" ? "My Pets & Rewards" : "Appointments & History"}
            </h2>
            <p className="text-[11px] sm:text-xs text-gray-400 font-semibold mt-0.5 block">
              {activeSection === "dashboard" ? "Here's what's happening with your pets and loyalty rewards." : activeSection === "pets" ? "Manage your registered pets and view loyalty cards." : "View active bookings and completed service history."}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => fetchData()}
              title="Refresh Dashboard"
              className="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold rounded-xl text-xs sm:text-sm flex items-center gap-1.5 transition-all shadow-sm"
            >
              <span></span> <span className="hidden sm:inline">Refresh</span>
            </button>
            <button
              onClick={() => setActiveTab("booking")}
              className="px-3.5 sm:px-5 py-2 sm:py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-xl shadow-md hover:scale-105 transition-all text-xs sm:text-sm flex items-center gap-1.5 sm:gap-2 shrink-0"
            >
              <ScissorsIcon size={16} color="white" /> Book Now
            </button>
          </div>
        </header>

        {/* Main content body */}
        <main className="flex-1 p-6 md:p-8 overflow-y-auto bg-[#f8f6f4]">

        {loading && (
          <div className="flex justify-center py-20 text-gray-400">
            <div className="w-10 h-10 border-4 border-gray-200 border-t-gray-600 rounded-full animate-spin"></div>
          </div>
        )}

        {error && (
          <div className="p-6 bg-red-50 border border-red-100 rounded-2xl text-red-600 font-bold">
            ⚠️ {error}
          </div>
        )}

        {!loading && !error && activeSection === "dashboard" && (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* LEFT COLUMN: Upcoming & Loyalty */}
            <div className="lg:col-span-2 space-y-6">
              
              {/* Active & Ongoing Appointments */}
              <div className="bg-[#eef4f6] rounded-3xl p-6 border border-[#d8e6eb] space-y-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-[#5b7b88] font-bold text-sm">
                    <span className="text-base">🐾</span> Active &amp; Upcoming Appointments
                  </div>
                  {activeAppointments.length > 0 && (
                    <span className="text-xs font-black bg-[#6992a5] text-white px-2.5 py-0.5 rounded-full">
                      {activeAppointments.length} Active
                    </span>
                  )}
                </div>
                
                {activeAppointments.length > 0 ? (
                  activeAppointments.map((appt) => (
                    <div key={appt._id} className="space-y-2">
                      {/* Ready for pickup alert if applicable */}
                      {appt.isReadyForPickup && (
                        <div className="bg-emerald-50 border-2 border-emerald-300 rounded-2xl p-3 flex items-center justify-between animate-pulse">
                          <div className="flex items-center gap-2 text-emerald-800 font-black text-xs">
                            <span className="text-lg">🛍️</span>
                            <span>Your pet is ready for pickup at the salon!</span>
                          </div>
                          <span className="text-[10px] font-extrabold uppercase bg-emerald-600 text-white px-2.5 py-1 rounded-full">
                            Ready
                          </span>
                        </div>
                      )}

                      {appt.pets.map((pet, idx) => (
                        <div key={idx} className="bg-[#f8fafb] rounded-2xl p-5 border border-[#e1ebf0] flex flex-col sm:flex-row sm:items-center gap-5 relative mb-3 shadow-sm">
                          <div className="w-24 h-24 bg-[#e6eff2] rounded-2xl flex items-center justify-center text-5xl shrink-0 overflow-hidden shadow-inner">
                            {pet.photoUrl ? <img src={pet.photoUrl} alt={pet.petName} className="w-full h-full object-cover" /> : (pet.petType === "cat" ? "🐱" : "🐶")}
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="flex justify-between items-start gap-2 flex-wrap">
                              <h3 className="text-2xl font-bold text-gray-800 mb-1">{pet.petName}</h3>
                              <span className={`px-3 py-1 text-xs font-bold rounded-full ${
                                appt.status === "ongoing" ? "bg-purple-100 text-purple-800 border border-purple-200" :
                                appt.status === "confirmed" ? "bg-emerald-100 text-emerald-700" :
                                appt.status === "pending" ? "bg-amber-100 text-amber-700" :
                                "bg-orange-100 text-orange-700"
                              }`}>
                                {appt.status === "ongoing" ? "✂️ On Going" :
                                 appt.status === "confirmed" ? "✓ Confirmed" :
                                 appt.status === "pending" ? "⧗ Pending" :
                                 appt.status === "reschedule_requested" ? "🔄 Resched Req." :
                                 "⚠️ Cancel Req."}
                              </span>
                            </div>
                            <p className="text-[#5b7b88] text-sm mb-1 font-medium">
                              {getApptScheduleDetails(appt).dateStr} {getApptScheduleDetails(appt).timeStr !== "Not specified" ? `· ${getApptScheduleDetails(appt).timeStr}` : ""}
                            </p>
                            <p className="text-gray-500 text-sm mb-1 flex items-center gap-2">
                              <PawIcon size={14} className="text-purple-500" /> {pet.breed || "Mixed Breed"}
                            </p>
                            <p className="text-gray-500 text-sm flex items-center gap-2">
                              <FileTextIcon size={14} className="text-purple-500" /> Service: <span className="capitalize font-semibold text-gray-700">{pet.serviceType === "both" ? "Hotel & Grooming" : pet.serviceType}</span>
                            </p>

                            {/* Reschedule request detail banner */}
                            {appt.status === "reschedule_requested" && (
                              <div className="mt-3 bg-orange-50 text-orange-800 text-xs font-bold p-3 rounded-2xl border border-orange-200 space-y-1">
                                <div className="flex items-center justify-between">
                                  <span>🔄 Reschedule Request Pending</span>
                                  <span className="text-[10px] bg-orange-200/60 px-2 py-0.5 rounded-full">Pending Approval</span>
                                </div>
                                {appt.rescheduleRequestedDate && (
                                  <div className="text-[11px] text-gray-600 pt-1 border-t border-orange-200/50">
                                    <div><span className="font-bold text-gray-500">Current:</span> <span className="line-through text-gray-400">{getApptScheduleDetails(appt).dateStr} {getApptScheduleDetails(appt).timeStr !== "Not specified" ? `at ${getApptScheduleDetails(appt).timeStr}` : ""}</span></div>
                                    <div><span className="font-bold text-orange-700">Requested:</span> <span className="font-extrabold text-orange-900">{new Date(appt.rescheduleRequestedDate).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" })}{appt.rescheduleRequestedTime ? ` at ${appt.rescheduleRequestedTime}` : ""}</span></div>
                                  </div>
                                )}
                                {appt.rescheduleReason && (
                                  <p className="text-[10px] text-orange-900 pt-0.5">
                                    <strong>Reason:</strong> {appt.rescheduleReason}
                                  </p>
                                )}
                              </div>
                            )}

                            {/* Cancel request detail banner */}
                            {appt.status === "cancel_requested" && (
                              <div className="mt-3 bg-red-50 text-red-800 text-xs font-bold p-3 rounded-2xl border border-red-200 space-y-1">
                                <div className="flex items-center justify-between">
                                  <span>⚠️ Cancellation Request Pending</span>
                                  <span className="text-[10px] bg-red-200/60 px-2 py-0.5 rounded-full">Pending Approval</span>
                                </div>
                                {appt.cancelReason && (
                                  <p className="text-[11px] text-red-700 font-normal">
                                    <strong>Reason:</strong> {appt.cancelReason}
                                  </p>
                                )}
                              </div>
                            )}
                          </div>

                          <div className="sm:absolute sm:bottom-5 sm:right-5 flex flex-wrap gap-2">
                            <button onClick={() => setAppointmentDetailsModal({ appt, pet })} className="w-full sm:w-auto px-4 py-2 bg-blue-50 hover:bg-blue-100 transition-colors text-blue-600 text-xs font-bold rounded-xl border border-blue-200">
                              View Details
                            </button>
                            {(appt.status === "pending" || appt.status === "confirmed") && (
                              <>
                                <button onClick={() => setActionModal({ isOpen: true, apt: appt, type: "reschedule" })} className="w-full sm:w-auto px-4 py-2 bg-orange-100 hover:bg-orange-200 transition-colors text-orange-700 text-xs font-bold rounded-xl border border-orange-200">
                                  Reschedule
                                </button>
                                <button onClick={() => setActionModal({ isOpen: true, apt: appt, type: "cancel" })} className="w-full sm:w-auto px-4 py-2 bg-red-50 hover:bg-red-100 transition-colors text-red-600 text-xs font-bold rounded-xl border border-red-200">
                                  Cancel
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))
                ) : (
                  <div className="bg-[#f8fafb] rounded-2xl p-8 border border-[#e1ebf0] text-center">
                    <p className="text-[#5b7b88] font-medium mb-3">No active or upcoming appointments.</p>
                    <button onClick={() => setActiveTab("booking")} className="px-5 py-2.5 bg-[#6992a5] hover:bg-[#5b7b88] transition-colors text-white text-sm font-bold rounded-xl">
                      Book Now
                    </button>
                  </div>
                )}
              </div>

              {/* Loyalty Rewards & Cards Section on Dashboard */}
              {myPets.length > 0 && (
                <div className="bg-white rounded-3xl p-6 border-2 border-purple-100 shadow-sm space-y-4">
                  <div className="flex items-center justify-between border-b border-purple-50 pb-3">
                    <div className="flex items-center gap-2">
                      <span className="text-xl">⭐</span>
                      <div>
                        <h3 className="text-base font-black text-gray-800">Loyalty Cards &amp; Visit Rewards</h3>
                        <p className="text-[11px] text-gray-400 font-medium">Earn stamps on every completed grooming visit!</p>
                      </div>
                    </div>
                    <button
                      onClick={() => setActiveSection("pets")}
                      className="text-xs font-bold text-purple-600 hover:text-purple-800 transition-colors"
                    >
                      View All Pets →
                    </button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {myPets.map((pet) => (
                      <div key={pet._id || pet.petName} className="p-3 bg-gradient-to-br from-purple-50/50 to-pink-50/50 rounded-2xl border border-purple-100">
                        <LoyaltyCard pet={pet} />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Recent Booking History on Dashboard */}
              <div className="bg-white rounded-3xl p-6 border border-gray-200 shadow-sm space-y-4">
                <div className="flex items-center justify-between border-b border-gray-100 pb-3">
                  <div className="flex items-center gap-2 text-gray-800 font-black text-base">
                    <FileTextIcon size={18} className="text-purple-600" />
                    <span>Recent Completed &amp; Past Bookings</span>
                  </div>
                  {pastAppointments.length > 0 && (
                    <button
                      onClick={() => {
                        setActiveSection("bookings");
                        setBookingFilter("history");
                      }}
                      className="text-xs font-bold text-purple-600 hover:text-purple-800 transition-colors"
                    >
                      View All History ({pastAppointments.length}) →
                    </button>
                  )}
                </div>

                {pastAppointments.length === 0 ? (
                  <div className="p-6 bg-gray-50 rounded-2xl text-center text-gray-400 text-xs font-medium space-y-1">
                    <p className="font-bold text-gray-600">No past bookings yet.</p>
                    <p>When you complete appointments at Furpect Tails, your history and visit counts will appear here!</p>
                  </div>
                ) : (
                  <div className="space-y-3">
                    {pastAppointments.slice(0, 3).map((appt) => {
                      const sched = getApptScheduleDetails(appt);
                      const status = STATUS_STYLES[appt.status] || STATUS_STYLES.pending;
                      const petNames = (appt.pets || []).map((p) => p.petName).join(", ") || "Pet";
                      const sType = appt.pets?.[0]?.serviceType === "both" ? "Hotel & Grooming" : (appt.pets?.[0]?.serviceType || "Service");

                      return (
                        <div key={appt._id} className="p-4 bg-gray-50 rounded-2xl border border-gray-100 flex flex-col sm:flex-row sm:items-center justify-between gap-3 hover:bg-purple-50/40 transition-colors">
                          <div>
                            <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider">{sched.dateStr}</p>
                            <p className="font-bold text-gray-800 text-sm">
                              {petNames} · <span className="capitalize text-purple-700">{sType}</span>
                            </p>
                          </div>
                          <div className="flex items-center gap-3">
                            <span className={`px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-wide ${status.bg} ${status.text}`}>
                              {status.label}
                            </span>
                            <button
                              onClick={() => setAppointmentDetailsModal({ appt, pet: appt.pets?.[0] })}
                              className="px-3.5 py-1.5 bg-white border border-gray-200 hover:bg-gray-50 text-gray-700 text-xs font-bold rounded-xl shadow-sm transition-colors"
                            >
                              Details
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

            </div>

            {/* RIGHT COLUMN: Quick Actions & Notifications */}
            <div className="space-y-6">
              
              {/* Quick Actions Grid Removed */}

              {/* Reminders / Notifications */}
              <div className="bg-[#eaf1ed] rounded-3xl p-6 border border-[#d5e5db]">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2 text-[#5c856e] font-medium">
                    <BellIcon size={18} color="#5c856e" /> Notifications
                  </div>
                </div>
                
                <div className="space-y-3">
                  {/* Rejected Booking Notifications */}
                  {appointments.filter(a => a.status === "rejected" || (a.status === "cancelled" && a.rejectReason)).map(apt => (
                    <div key={apt._id} className="bg-red-50 rounded-2xl p-4 border-2 border-red-200 shadow-sm animate-in fade-in">
                      <p className="text-sm text-red-800 font-bold mb-1 flex items-center gap-2">
                        <span className="text-base">🚫</span>
                        <span>Booking Rejected for {(apt.pets || []).map(p => p.petName).join(", ") || "your pet"}</span>
                      </p>
                      <p className="text-xs text-red-700 ml-6 mb-2">
                        {apt.rejectReason || apt.cancelReason ? (
                          <span><strong>Reason:</strong> {apt.rejectReason || apt.cancelReason}</span>
                        ) : (
                          "Your booking request could not be accepted at this time."
                        )}
                      </p>
                      {apt.downpaymentAmount > 0 && apt.paymentMethod !== "Cash" && (
                        <div className="text-[11px] text-red-700 ml-6 mb-2.5 bg-red-100/70 p-2.5 rounded-xl border border-red-200 leading-snug">
                          💰 <strong>Downpayment Refund:</strong> We noted your ₱{apt.downpaymentAmount.toLocaleString()} payment. Please message us on Live Chat or visit our clinic for your refund.
                        </div>
                      )}
                      <div className="flex flex-wrap gap-2 ml-6">
                        <button 
                          onClick={() => setActiveTab("booking")}
                          className="px-3.5 py-1.5 bg-red-600 hover:bg-red-700 text-white rounded-xl text-xs font-bold shadow-sm transition-colors"
                        >
                          Book Another Date
                        </button>
                        <button 
                          onClick={() => setActiveTab("contact")}
                          className="px-3.5 py-1.5 bg-white text-red-700 border border-red-200 hover:bg-red-100/50 rounded-xl text-xs font-bold transition-colors"
                        >
                          Contact Us
                        </button>
                      </div>
                    </div>
                  ))}

                  {appointments.filter(a => a.isReadyForPickup).map(apt => (
                    <div key={apt._id} className="bg-purple-50 rounded-2xl p-4 border border-purple-200 shadow-sm">
                      <p className="text-sm text-purple-800 font-bold mb-2 flex items-center gap-2">
                        <GiftIcon size={18} className="text-purple-500" />
                        {apt.pets[0]?.petName} is ready for pickup!
                      </p>
                      <p className="text-xs text-purple-600 ml-7 mb-3">The grooming session is complete. You can now pick them up.</p>
                      <div className="flex gap-2 ml-7">
                        <button 
                          onClick={() => handlePickupConfirmation(apt)}
                          className="px-4 py-1.5 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-xs font-bold shadow-sm transition-colors"
                        >
                          Confirm Picked Up
                        </button>
                      </div>
                    </div>
                  ))}

                  {(() => {
                    const confirmedNeedsConfirmation = activeAppointments.find(a => a.status === "confirmed" && a.customerConfirmation === "pending");
                    if (!confirmedNeedsConfirmation) return null;
                    return (
                      <div className="bg-blue-50 rounded-2xl p-4 border border-blue-200 shadow-sm">
                        <p className="text-sm text-blue-800 font-bold mb-2 flex items-center gap-2">
                          <CalendarIcon size={18} className="text-blue-500" />
                          Confirm your appointment for {confirmedNeedsConfirmation.pets[0]?.petName}?
                        </p>
                        <p className="text-xs text-blue-600 ml-7 mb-3">Please confirm if you are still coming.</p>
                        <div className="flex gap-2 ml-7">
                          <button onClick={() => handleConfirmation(confirmedNeedsConfirmation, "yes")} className="px-4 py-1.5 bg-blue-500 text-white rounded-lg text-xs font-bold hover:bg-blue-600">Yes, I'm coming</button>
                          <button onClick={() => handleConfirmation(confirmedNeedsConfirmation, "no")} className="px-4 py-1.5 bg-white text-red-500 border border-red-200 rounded-lg text-xs font-bold hover:bg-red-50">No, I can't make it</button>
                        </div>
                      </div>
                    );
                  })()}

                  {(() => {
                    const confirmedReminder = activeAppointments.find(a => a.status === "confirmed" && a.customerConfirmation !== "pending" && a.pets?.[0]);
                    if (!confirmedReminder) return null;
                    return (
                      <div className="bg-white/80 rounded-2xl p-4 border border-[#d5e5db] shadow-sm">
                        <p className="text-xs text-gray-700 leading-relaxed flex items-center gap-1.5">
                          <BellIcon size={14} className="text-emerald-500" /> 
                          <span><span className="font-bold">Reminder:</span> {confirmedReminder.pets[0].petName}'s appointment is coming up! Please arrive 10 mins early.</span>
                        </p>
                      </div>
                    );
                  })()}

                  {activeAppointments.length === 0 && appointments.filter(a => a.isReadyForPickup || a.status === "rejected" || (a.status === "cancelled" && a.rejectReason)).length === 0 && (
                    <p className="text-sm text-[#5c856e] text-center py-2">No new notifications.</p>
                  )}
                </div>
              </div>


            </div>
          </div>
        )}

        {/* ── APPOINTMENTS & HISTORY SECTION ── */}
        {!loading && !error && activeSection === "bookings" && (
          <div className="space-y-6 max-w-4xl mx-auto">

            {/* Filter Tabs */}
            <div className="flex items-center gap-2 p-1.5 bg-white rounded-2xl border border-gray-200 shadow-sm w-fit">
              <button
                onClick={() => setBookingFilter("all")}
                className={`px-4 py-2 rounded-xl text-xs font-bold transition-all ${
                  bookingFilter === "all"
                    ? "bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-sm"
                    : "text-gray-600 hover:text-purple-600 hover:bg-gray-50"
                }`}
              >
                All Bookings ({appointments.length})
              </button>
              <button
                onClick={() => setBookingFilter("active")}
                className={`px-4 py-2 rounded-xl text-xs font-bold transition-all ${
                  bookingFilter === "active"
                    ? "bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-sm"
                    : "text-gray-600 hover:text-purple-600 hover:bg-gray-50"
                }`}
              >
                Active &amp; Ongoing ({activeAppointments.length})
              </button>
              <button
                onClick={() => setBookingFilter("history")}
                className={`px-4 py-2 rounded-xl text-xs font-bold transition-all ${
                  bookingFilter === "history"
                    ? "bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-sm"
                    : "text-gray-600 hover:text-purple-600 hover:bg-gray-50"
                }`}
              >
                Past History ({pastAppointments.length})
              </button>
            </div>

            {/* 1. ACTIVE & ONGOING BOOKINGS */}
            {(bookingFilter === "all" || bookingFilter === "active") && (
            <div className="space-y-4">
              <div className="flex items-center justify-between mb-2">
                <h2 className="text-xl sm:text-2xl font-black text-gray-800 flex items-center gap-2">
                  <span className="text-purple-600">⚡</span> Active &amp; Ongoing Bookings
                </h2>
                <span className="text-xs font-black bg-purple-100 text-purple-800 px-3 py-1 rounded-full">
                  {activeAppointments.length} Active
                </span>
              </div>

              {activeAppointments.length === 0 ? (
                <div className="p-8 bg-white rounded-3xl border border-gray-200 text-center text-gray-400">
                  <p className="font-medium text-sm">No active or ongoing bookings right now.</p>
                </div>
              ) : (
                activeAppointments.map((appt) => {
                  const status = STATUS_STYLES[appt.status] || STATUS_STYLES.pending;
                  const sched = getApptScheduleDetails(appt);

                  return (
                    <div key={appt._id} className="bg-white rounded-3xl border-2 border-purple-100 p-6 shadow-sm space-y-4">
                      {/* Ready for pickup banner */}
                      {appt.isReadyForPickup && (
                        <div className="bg-emerald-50 border-2 border-emerald-300 rounded-2xl p-3 flex items-center justify-between animate-pulse">
                          <div className="flex items-center gap-2 text-emerald-800 font-black text-xs">
                            <span className="text-lg">🛍️</span>
                            <span>Your pet is ready for pickup at the salon!</span>
                          </div>
                          <span className="text-[10px] font-extrabold uppercase bg-emerald-600 text-white px-2.5 py-1 rounded-full">
                            Ready for Pickup
                          </span>
                        </div>
                      )}

                      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 border-b border-gray-100 pb-4">
                        <div>
                          <p className="text-xs text-gray-400 font-bold uppercase tracking-wider mb-1">{sched.dateStr}</p>
                          <p className="font-black text-gray-800 text-lg">
                            {appt.pets?.length} Pet{appt.pets?.length !== 1 ? "s" : ""} Booked
                            {sched.timeStr !== "Not specified" && <span className="text-sm font-medium text-gray-500 ml-2">at {sched.timeStr}</span>}
                          </p>
                        </div>
                        <div className="flex items-center gap-3">
                          <span className={`px-3 py-1 rounded-full text-xs font-black uppercase tracking-wide ${
                            appt.status === "ongoing" ? "bg-purple-100 text-purple-800 border border-purple-300" :
                            appt.status === "confirmed" ? "bg-emerald-100 text-emerald-700" :
                            appt.status === "pending" ? "bg-amber-100 text-amber-700" :
                            "bg-orange-100 text-orange-700"
                          }`}>
                            {appt.status === "ongoing" ? "✂️ On Going" : status.label}
                          </span>
                          <span className="text-xl font-black text-gray-800">
                            ₱{(appt.totalPrice || 0).toLocaleString()}
                          </span>
                        </div>
                      </div>

                      {/* Reschedule request pending banner */}
                      {appt.status === "reschedule_requested" && (
                        <div className="bg-orange-50 p-3.5 rounded-2xl border border-orange-200 space-y-1.5">
                          <div className="flex items-center justify-between">
                            <p className="text-xs text-orange-800 font-bold">
                              🔄 Reschedule Request Pending
                            </p>
                            <span className="text-[10px] font-bold bg-orange-200/60 text-orange-800 px-2 py-0.5 rounded-full">
                              Pending Approval
                            </span>
                          </div>
                          {appt.rescheduleRequestedDate && (
                            <div className="text-xs grid grid-cols-1 sm:grid-cols-2 gap-2 pt-1 border-t border-orange-200/60">
                              <div>
                                <span className="text-[10px] font-bold text-gray-400 uppercase block">Current Schedule</span>
                                <span className="font-semibold text-gray-500 line-through">
                                  {sched.dateStr} {sched.timeStr !== "Not specified" ? `at ${sched.timeStr}` : ""}
                                </span>
                              </div>
                              <div>
                                <span className="text-[10px] font-bold text-orange-700 uppercase block">Requested Reschedule</span>
                                <span className="font-black text-orange-950">
                                  📅 {new Date(appt.rescheduleRequestedDate).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" })}
                                  {appt.rescheduleRequestedTime ? ` at ${appt.rescheduleRequestedTime}` : ""}
                                </span>
                              </div>
                            </div>
                          )}
                          <p className="text-[11px] text-orange-800 pt-0.5">
                            <strong>Reason:</strong> {appt.rescheduleReason || "Schedule conflict"}
                          </p>
                        </div>
                      )}

                      {/* Cancel request pending banner */}
                      {appt.status === "cancel_requested" && (
                        <div className="bg-red-50 p-3.5 rounded-2xl border border-red-200 space-y-1">
                          <div className="flex items-center justify-between">
                            <p className="text-xs text-red-800 font-bold">
                              ⚠️ Cancellation Request Pending
                            </p>
                            <span className="text-[10px] font-bold bg-red-200/60 text-red-800 px-2 py-0.5 rounded-full">
                              Under Review
                            </span>
                          </div>
                          {appt.cancelReason && (
                            <p className="text-[11px] text-red-700">
                              <strong>Reason:</strong> {appt.cancelReason}
                            </p>
                          )}
                        </div>
                      )}

                      {/* Pets in booking */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {(appt.pets || []).map((pet, i) => (
                          <div key={i} className="flex items-center gap-3 p-4 bg-[#f8f6f4] border border-gray-100 rounded-2xl">
                            {pet.petType === "cat" ? <CatIcon size={24} color="#e0a458" /> : <DogIcon size={24} color="#6992a5" />}
                            <div className="flex-1 min-w-0">
                              <p className="font-bold text-gray-800 text-sm truncate">{pet.petName}</p>
                              <p className="text-xs text-gray-500 capitalize truncate">
                                {pet.serviceType === "both" ? "Hotel & Grooming" : pet.serviceType}
                                {pet.grooming?.date ? ` · ${new Date(pet.grooming.date).toLocaleDateString("en-PH", { month: "short", day: "numeric" })}` : ""}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Action buttons */}
                      <div className="flex flex-wrap items-center justify-end gap-2 pt-2 border-t border-gray-100">
                        <button
                          onClick={() => setCheckInQrModal(appt)}
                          className="px-3.5 py-2 bg-purple-50 hover:bg-purple-100 text-purple-700 font-bold rounded-xl text-xs transition-colors flex items-center gap-1.5 border border-purple-200 shadow-sm"
                          title="Show Check-in QR code for clinic reception"
                        >
                          <span>📱</span> Check-In QR
                        </button>
                        <button
                          onClick={() => setAppointmentDetailsModal({ appt, pet: appt.pets?.[0] })}
                          className="px-4 py-2 bg-blue-50 hover:bg-blue-100 text-blue-600 font-bold rounded-xl text-xs transition-colors"
                        >
                          View Details
                        </button>
                        {(appt.status === "pending" || appt.status === "confirmed") && (
                          <>
                            <button
                              onClick={() => setActionModal({ isOpen: true, apt: appt, type: "reschedule" })}
                              className="px-4 py-2 bg-orange-100 hover:bg-orange-200 text-orange-700 font-bold rounded-xl text-xs transition-colors border border-orange-200"
                            >
                              Reschedule
                            </button>
                            <button
                              onClick={() => setActionModal({ isOpen: true, apt: appt, type: "cancel" })}
                              className="px-4 py-2 bg-red-50 hover:bg-red-100 text-red-600 font-bold rounded-xl text-xs transition-colors border border-red-200"
                            >
                              Cancel
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            )}

            {/* 2. PAST BOOKING HISTORY */}
            {(bookingFilter === "all" || bookingFilter === "history") && (
            <div className="space-y-4 pt-4 border-t-2 border-gray-200">
              <div className="flex items-center justify-between mb-2">
                <h2 className="text-xl sm:text-2xl font-black text-gray-800 flex items-center gap-2">
                  <FileTextIcon size={24} className="text-purple-600" /> Past Booking History
                </h2>
                <span className="text-xs font-black bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                  {pastAppointments.length} Completed / Past
                </span>
              </div>

              {pastAppointments.length === 0 ? (
                <div className="p-8 bg-white rounded-3xl border border-gray-200 text-center text-gray-400">
                  <p className="font-medium text-sm">No completed or past bookings yet.</p>
                </div>
              ) : (
                pastAppointments.map((appt) => {
                  const status = STATUS_STYLES[appt.status] || STATUS_STYLES.pending;
                  const sched = getApptScheduleDetails(appt);

                  return (
                    <div key={appt._id} className="bg-white rounded-3xl border border-gray-200 p-6 shadow-sm space-y-3">
                      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 border-b border-gray-100 pb-3">
                        <div>
                          <p className="text-xs text-gray-400 font-bold uppercase tracking-wider mb-1">{sched.dateStr}</p>
                          <p className="font-bold text-gray-800">
                            {appt.pets?.length} Pet{appt.pets?.length !== 1 ? "s" : ""} Booked
                          </p>
                        </div>
                        <div className="flex items-center gap-3">
                          <span className={`px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wide ${status.bg} ${status.text}`}>
                            {status.label}
                          </span>
                          <span className="text-lg font-black text-gray-800">
                            ₱{(appt.totalPrice || 0).toLocaleString()}
                          </span>
                        </div>
                      </div>

                      {/* Completed appointment review status */}
                      {appt.status === "completed" && !appt.rating && (
                        <div className="bg-gradient-to-r from-amber-50 to-pink-50 p-4 rounded-2xl border-2 border-amber-200/80 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 shadow-xs">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-2xl bg-amber-100 text-amber-700 flex items-center justify-center text-xl shrink-0">
                              ⭐
                            </div>
                            <div>
                              <p className="text-xs font-black text-gray-800">How was your pet's experience?</p>
                              <p className="text-[11px] text-gray-500 font-medium">Leave a review to let the Furpect Tails team know how they did!</p>
                            </div>
                          </div>
                          <button 
                            onClick={() => setFeedbackModal({ isOpen: true, apt: appt, rating: 5, feedback: "" })} 
                            className="px-4 py-2 bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-bold rounded-xl text-xs transition-all shadow-sm hover:shadow shrink-0"
                          >
                            ⭐ Leave a Review
                          </button>
                        </div>
                      )}

                      {appt.status === "completed" && appt.rating && (
                        <div className="p-4 bg-gradient-to-r from-amber-50/70 to-yellow-50/70 rounded-2xl border border-amber-200 text-sm space-y-2">
                          <div className="flex justify-between items-center">
                            <div className="flex items-center gap-2">
                              <span className="text-base">⭐</span>
                              <p className="text-xs font-black text-amber-900 uppercase tracking-wide">Your Review</p>
                              {appt.reviewedAt && (
                                <span className="text-[10px] text-gray-400 font-medium">
                                  · {new Date(appt.reviewedAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                                </span>
                              )}
                            </div>
                            <div className="flex items-center gap-2">
                              <div className="flex items-center gap-0.5 text-yellow-400 text-base">
                                {[1, 2, 3, 4, 5].map((s) => (
                                  <span key={s}>{s <= appt.rating ? "★" : "☆"}</span>
                                ))}
                              </div>
                              <button
                                onClick={() => setFeedbackModal({ isOpen: true, apt: appt, rating: appt.rating || 5, feedback: appt.feedback || "" })}
                                className="px-2.5 py-1 bg-white hover:bg-amber-100 text-amber-800 font-bold rounded-lg text-[11px] border border-amber-300 transition-colors shadow-2xs"
                                title="Edit your review"
                              >
                                ✏️ Edit
                              </button>
                            </div>
                          </div>
                          {appt.feedback ? (
                            <p className="text-gray-700 italic text-[13px] bg-white/70 p-2.5 rounded-xl border border-amber-100">
                              "{appt.feedback}"
                            </p>
                          ) : (
                            <p className="text-[11px] text-gray-400 italic">No written comment provided.</p>
                          )}
                        </div>
                      )}

                      {appt.status === "rejected" && (
                        <div className="bg-red-50 p-3 rounded-2xl border border-red-200 text-xs">
                          <p className="text-red-700 font-bold flex items-center gap-1.5 mb-0.5">
                            <span>🚫</span> Booking Rejected
                          </p>
                          <p className="text-red-600">
                            <strong>Reason:</strong> {appt.rejectReason || appt.cancelReason || "No reason specified"}
                          </p>
                        </div>
                      )}

                      {appt.status === "cancelled" && (
                        <div className="bg-red-50 p-3 rounded-2xl border border-red-200 text-xs">
                          <p className="text-red-700 font-bold mb-0.5">Booking Cancelled</p>
                          <p className="text-red-600">
                            <strong>Reason:</strong> {appt.cancelReason || appt.rejectReason || "Cancelled"}
                          </p>
                        </div>
                      )}

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {(appt.pets || []).map((pet, i) => (
                          <div key={i} className="flex items-center gap-3 p-3 bg-[#f8f6f4] border border-gray-100 rounded-2xl">
                            {pet.petType === "cat" ? <CatIcon size={22} color="#e0a458" /> : <DogIcon size={22} color="#6992a5" />}
                            <div className="flex-1 min-w-0">
                              <p className="font-bold text-gray-800 text-sm truncate">{pet.petName}</p>
                              <p className="text-xs text-gray-500 capitalize truncate">
                                {pet.serviceType === "both" ? "Hotel & Grooming" : pet.serviceType}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Action buttons for past booking */}
                      <div className="flex items-center justify-end gap-2 pt-2 border-t border-gray-100">
                        <button
                          onClick={() => setAppointmentDetailsModal({ appt, pet: appt.pets?.[0] })}
                          className="px-4 py-2 bg-purple-50 hover:bg-purple-100 text-purple-700 font-bold rounded-xl text-xs transition-colors"
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
            )}
          </div>
        )}

        {/* ── MY PETS SECTION ── */}
        {!loading && !error && activeSection === "pets" && (
          <div className="space-y-6 max-w-4xl mx-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2"><PawIcon size={24} className="text-gray-800" /> My Pets</h2>
              <button 
                onClick={() => setAddingPet(true)} 
                className="px-5 py-2.5 bg-gradient-to-r from-purple-600 to-pink-600 hover:opacity-90 transition-all text-white text-sm font-bold rounded-xl shadow-md flex items-center gap-1.5"
              >
                <span>+</span> Add Pet
              </button>
            </div>
            {myPets.length === 0 ? (
              <div className="text-center py-20 bg-white rounded-3xl border border-gray-200 shadow-sm">
                <div className="flex justify-center mb-4">
                  <PawIcon size={48} className="text-gray-400" />
                </div>
                <h3 className="text-xl font-bold text-gray-700 mb-2">No pets registered yet</h3>
                <p className="text-gray-500">Your pets will appear here after your first booking.</p>
              </div>
            ) : (
              myPets.map((pet) => (
                <div className="bg-white rounded-3xl shadow-sm border border-gray-200 overflow-hidden" key={pet._id}>
                   <PetCard
                    pet={pet}
                    userToken={user.token}
                    userId={user._id}
                    onSaved={fetchData}
                    onViewHistory={(p) => setPetHistoryModal(p)}
                     onZoomImage={setZoomImage}
                  />
                </div>
              ))
            )}
          </div>
        )}

        </main>
      </div>



      {/* Add Pet Modal */}
      {addingPet && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200" onClick={(e) => { if(e.target === e.currentTarget) setAddingPet(false); }}>
          <div className="bg-white rounded-[2rem] w-full max-w-lg shadow-2xl relative overflow-hidden flex flex-col max-h-[90vh] animate-in zoom-in-95 duration-200">

            {/* Header */}
            <div className="flex items-center justify-between px-8 pt-7 pb-5 bg-gradient-to-r from-purple-600 to-pink-600">
              <div className="flex items-center gap-3">
                <span className="text-2xl">🐾</span>
                <div>
                  <h3 className="font-black text-white text-lg">Add New Pet</h3>
                  <p className="text-purple-200 text-xs">This pet will be saved to your profile</p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setAddingPet(false)}
                className="w-9 h-9 rounded-full bg-white/20 hover:bg-white/30 text-white font-black flex items-center justify-center transition-all text-lg"
              >
                ×
              </button>
            </div>

            <div className="px-8 py-6 overflow-y-auto flex-1 space-y-5">
              
              {/* Pet Name */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Pet Name <span className="text-red-500">*</span></label>
                <input 
                  type="text"
                  className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 font-medium transition-all" 
                  value={newPetForm.petName} 
                  onChange={(e) => setNewPetForm({ ...newPetForm, petName: e.target.value })} 
                  placeholder="e.g. Bella"
                />
              </div>

              {/* Pet Type Toggle Buttons */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Type <span className="text-red-500">*</span></label>
                <div className="flex gap-3">
                  {["dog", "cat"].map(t => (
                    <button
                      key={t}
                      type="button"
                      onClick={() => setNewPetForm({ ...newPetForm, petType: t, breed: "" })}
                      className={`flex-1 py-3 rounded-2xl font-bold border-2 capitalize transition-all ${
                        newPetForm.petType === t ? "bg-purple-600 border-purple-600 text-white shadow-lg" : "bg-white border-purple-100 text-gray-500 hover:border-purple-300"
                      }`}
                    >
                      {t === "dog" ? "🐶 Dog" : "🐱 Cat"}
                    </button>
                  ))}
                </div>
              </div>

              {/* Breed */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Breed <span className="text-red-500">*</span></label>
                {newPetForm.breed !== "Other" ? (
                  <select 
                    className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 font-medium transition-all" 
                    value={newPetForm.breed} 
                    onChange={(e) => setNewPetForm({ ...newPetForm, breed: e.target.value })} 
                  >
                    <option value="">Select Breed</option>
                    {(newPetForm.petType === "dog" ? DOG_BREEDS : CAT_BREEDS).map(b => (
                      <option key={b} value={b}>{b}</option>
                    ))}
                    <option value="Other">Other / Custom Breed</option>
                  </select>
                ) : (
                  <div className="relative">
                    <input 
                      type="text" 
                      className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 font-medium transition-all" 
                      placeholder="Enter custom breed..."
                      value={newPetForm.customBreed}
                      onChange={(e) => setNewPetForm({ ...newPetForm, customBreed: e.target.value })}
                    />
                    <button 
                      type="button"
                      onClick={() => setNewPetForm({ ...newPetForm, breed: "" })}
                      className="absolute right-4 top-1/2 -translate-y-1/2 text-xs text-purple-500 font-bold"
                    >
                      List
                    </button>
                  </div>
                )}
              </div>

              {/* Gender */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Gender</label>
                <select 
                  className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 font-medium transition-all" 
                  value={newPetForm.gender} 
                  onChange={(e) => setNewPetForm({ ...newPetForm, gender: e.target.value })}
                >
                  <option value="male">Male ♂️</option>
                  <option value="female">Female ♀️</option>
                  <option value="unknown">Unknown</option>
                </select>
              </div>

              {/* Birthday */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Birthdate *</label>
                <input 
                  type="date"
                  max={getLocalDateString()}
                  className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 font-medium transition-all" 
                  value={newPetForm.birthday} 
                  onChange={(e) => setNewPetForm({ ...newPetForm, birthday: e.target.value })} 
                  required
                />
                {newPetForm.birthday && !isPetEligibleForGrooming(newPetForm.birthday, getLocalDateString()) && (
                  <p className="text-[11px] text-amber-700 font-semibold bg-amber-50 border border-amber-200 p-2.5 rounded-xl flex items-start gap-1.5 mt-1">
                    <span>⚠️</span>
                    <span>Notice: Furpect Tails is not accepting pets under 6 months old for grooming services.</span>
                  </p>
                )}
              </div>

              {/* Color / Markings */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Color / Markings <span className="text-gray-400 font-normal text-xs">(Optional)</span></label>
                <input 
                  className="w-full px-5 py-3.5 bg-gray-50 border-2 border-purple-100 rounded-2xl outline-none focus:border-purple-400 font-medium transition-all" 
                  value={newPetForm.colorMarkings} 
                  onChange={(e) => setNewPetForm({ ...newPetForm, colorMarkings: e.target.value })} 
                  placeholder="e.g. Golden with white paws"
                />
              </div>

              {/* Pet Photo Upload */}
              <div className="space-y-1.5">
                <label className="text-sm font-bold text-gray-700">Pet Photo <span className="text-gray-400 font-normal text-xs">(Optional)</span></label>
                <div className="flex items-start gap-4">
                  {newPetForm.photoUrl && (
                    <div className="relative flex-shrink-0">
                      <img
                        src={newPetForm.photoUrl}
                        alt="Pet preview"
                        className="w-20 h-20 object-cover rounded-2xl border-2 border-purple-100 shadow"
                      />
                      <button
                        type="button"
                        onClick={() => setNewPetForm({ ...newPetForm, photoUrl: "" })}
                        className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white rounded-full text-[10px] font-black flex items-center justify-center hover:bg-red-600"
                      >
                        ×
                      </button>
                    </div>
                  )}
                  <label className="flex-1 flex flex-col items-center justify-center border-2 border-dashed border-purple-200 rounded-2xl p-4 cursor-pointer hover:border-purple-400 hover:bg-purple-50/50 transition-all bg-white">
                    <span className="text-2xl mb-1">📷</span>
                    <span className="text-xs font-bold text-purple-500">{newPetForm.photoUrl ? "Change photo" : "Upload pet photo"}</span>
                    <span className="text-[10px] text-gray-400 mt-0.5">JPG, PNG • auto-compressed</span>
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={async (e) => {
                        const file = e.target.files?.[0];
                        if (!file) return;
                        const compressed = await compressImage(file);
                        setNewPetForm({ ...newPetForm, photoUrl: compressed });
                      }}
                    />
                  </label>
                </div>
              </div>

              {/* Medical & Health Information */}
              <div className="bg-purple-50/60 rounded-2xl p-4 space-y-3">
                <div className="flex items-center justify-between">
                  <p className="text-xs font-black uppercase tracking-widest text-purple-600">Medical & Health Information</p>
                  <span className="text-[9px] font-bold text-rose-600 bg-rose-50 px-2 py-0.5 rounded-full border border-rose-200">Vaccine Required</span>
                </div>
                <div className="flex items-center space-x-3">
                  <input 
                    type="checkbox" 
                    id="isVaccinated"
                    className="w-4 h-4 accent-purple-600 cursor-pointer rounded"
                    checked={newPetForm.health.isVaccinated}
                    onChange={(e) => setNewPetForm({ ...newPetForm, health: { ...newPetForm.health, isVaccinated: e.target.checked } })}
                  />
                  <label htmlFor="isVaccinated" className="text-sm font-bold text-gray-700 cursor-pointer">
                    Vaccinated (Anti-Rabies / Up-to-date)
                  </label>
                </div>
                {!newPetForm.health.isVaccinated && (
                  <p className="text-[11px] text-amber-800 bg-amber-50 border border-amber-200 p-2 rounded-xl">
                    ⚠️ <strong>Store Policy:</strong> Dogs and cats that are not vaccinated will NOT be accepted in the store.
                  </p>
                )}
                {newPetForm.health.isVaccinated && (
                  <div>
                    <label className="block text-xs font-bold text-gray-500 mb-1">Last Vaccination Date</label>
                    <input 
                      type="date"
                      className="w-full px-4 py-2.5 bg-white border-2 border-purple-100 rounded-xl outline-none focus:border-purple-400 text-sm font-medium" 
                      value={newPetForm.health.lastVaccinationDate}
                      onChange={(e) => setNewPetForm({ ...newPetForm, health: { ...newPetForm.health, lastVaccinationDate: e.target.value } })}
                    />
                  </div>
                )}
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-1">Medical Conditions</label>
                  <input 
                    className="w-full px-4 py-2.5 bg-white border-2 border-purple-100 rounded-xl outline-none focus:border-purple-400 text-sm font-medium" 
                    value={newPetForm.health.medicalConditions}
                    onChange={(e) => setNewPetForm({ ...newPetForm, health: { ...newPetForm.health, medicalConditions: e.target.value } })}
                    placeholder="e.g. Allergies, arthritis, etc."
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-1">Medications</label>
                  <input 
                    className="w-full px-4 py-2.5 bg-white border-2 border-purple-100 rounded-xl outline-none focus:border-purple-400 text-sm font-medium" 
                    value={newPetForm.health.medication}
                    onChange={(e) => setNewPetForm({ ...newPetForm, health: { ...newPetForm.health, medication: e.target.value } })}
                    placeholder="e.g. Heartworm pill monthly"
                  />
                </div>
              </div>

              {addingPetError && <p className="text-xs text-red-500 font-bold bg-red-50 p-3 rounded-xl border border-red-100">⚠️ {addingPetError}</p>}
            </div>
            
            {/* Footer Buttons */}
            <div className="px-8 py-5 border-t border-purple-50 flex gap-3 bg-purple-50/30">
              <button 
                onClick={() => { 
                  setAddingPet(false); 
                  setAddingPetError(null); 
                  setNewPetForm({ 
                    petName: "", petType: "dog", breed: "", customBreed: "", gender: "unknown", birthday: "", colorMarkings: "", photoUrl: "",
                    health: { isVaccinated: false, lastVaccinationDate: "", medicalConditions: "", medication: "" }
                  }); 
                }} 
                disabled={addingPetLoading} 
                className="flex-1 py-3 bg-white border-2 border-purple-200 text-purple-600 font-bold rounded-2xl hover:bg-purple-50 transition-all text-sm"
              >
                Cancel
              </button>
              <button 
                onClick={handleAddPet} 
                disabled={addingPetLoading} 
                className={`flex-1 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-black rounded-2xl transition-all shadow-lg text-sm ${
                  addingPetLoading ? "opacity-50 cursor-wait" : "hover:scale-[1.02] hover:shadow-purple-400/40"
                }`}
              >
                {addingPetLoading ? "Saving..." : "Save Pet 🐾"}
              </button>
            </div>

          </div>
        </div>
      )}

      {/* Pet History Modal */}
      {petHistoryModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[70] flex items-center justify-center p-4" onClick={(e) => { if(e.target === e.currentTarget) setPetHistoryModal(null); }}>
          <div className="bg-white rounded-3xl p-6 sm:p-8 w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-2xl relative animate-in fade-in zoom-in duration-200">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
                <span>📋</span> {petHistoryModal.petName}'s History
              </h2>
              <button onClick={() => setPetHistoryModal(null)} className="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 font-bold flex items-center justify-center transition-colors">×</button>
            </div>
            
            <div className="space-y-4">
              {(() => {
                const petAppts = appointments.filter(a => a.pets && a.pets.some(p => {
                  const idMatch = p.pet && petHistoryModal._id && (
                    (typeof p.pet === "string" ? p.pet : p.pet?._id?.toString?.() || p.pet?.toString?.()) === petHistoryModal._id.toString()
                  );
                  const nameMatch = p.petName?.trim().toLowerCase() === petHistoryModal.petName?.trim().toLowerCase();
                  return idMatch || nameMatch;
                }));
                
                if (petAppts.length === 0) {
                  return (
                    <div className="text-center py-10 bg-gray-50 rounded-2xl border border-gray-100">
                      <div className="text-4xl mb-3">📭</div>
                      <p className="text-gray-500 font-medium">No history found for this pet.</p>
                    </div>
                  );
                }
                
                return petAppts.map(appt => {
                  const status = STATUS_STYLES[appt.status] || STATUS_STYLES.pending;
                  const date = appt.createdAt ? new Date(appt.createdAt).toLocaleDateString("en-PH", { year: "numeric", month: "long", day: "numeric" }) : "N/A";
                  const petDetail = appt.pets.find(p => {
                    const idMatch = p.pet && petHistoryModal._id && (
                      (typeof p.pet === "string" ? p.pet : p.pet?._id?.toString?.() || p.pet?.toString?.()) === petHistoryModal._id.toString()
                    );
                    const nameMatch = p.petName?.trim().toLowerCase() === petHistoryModal.petName?.trim().toLowerCase();
                    return idMatch || nameMatch;
                  });
                  
                  return (
                    <div key={appt._id} className="bg-white rounded-2xl border border-gray-200 p-5 shadow-sm flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                      <div>
                        <p className="text-xs text-gray-400 font-bold uppercase tracking-wider mb-1">{date}</p>
                        <p className="font-bold text-gray-800 capitalize text-lg">{petDetail?.serviceType} Service</p>
                        {petDetail?.grooming?.date && (
                          <p className="text-sm text-gray-500 mt-1">
                            <span className="font-medium text-gray-600">Grooming Date:</span> {new Date(petDetail.grooming.date).toLocaleDateString("en-PH", { month: "long", day: "numeric", year: "numeric" })}
                          </p>
                        )}
                        {petDetail?.hotel?.checkInDate && (
                          <p className="text-sm text-gray-500 mt-1">
                            <span className="font-medium text-gray-600">Check-in:</span> {new Date(petDetail.hotel.checkInDate).toLocaleDateString("en-PH", { month: "short", day: "numeric" })}
                            {petDetail.hotel.checkOutDate && (
                              <>{" – "}<span className="font-medium text-gray-600">Check-out:</span> {new Date(petDetail.hotel.checkOutDate).toLocaleDateString("en-PH", { month: "short", day: "numeric" })}</>
                            )}
                          </p>
                        )}
                      </div>
                      <div className="flex flex-col items-end gap-2">
                        <span className={`px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide ${status.bg} ${status.text} text-center shadow-sm`}>
                          {status.label}
                        </span>
                        <span className="text-sm font-black text-gray-700">
                          ₱{(appt.totalPrice || 0).toLocaleString()} Total
                        </span>
                      </div>
                    </div>
                  );
                });
              })()}
            </div>
          </div>
        </div>
      )}

      {/* Action Modal (Cancel/Reschedule) */}
      {actionModal.isOpen && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl p-6 sm:p-8 w-full max-w-md shadow-2xl relative">
            <h2 className="text-2xl font-bold text-gray-800 mb-2 capitalize">
              Request {actionModal.type}
            </h2>
            <p className="text-xs text-gray-500 mb-6">Your request will be sent to the admin for approval.</p>
            
            <div className="space-y-4">
              {actionModal.type === "reschedule" && (
                <>
                  {/* Current Schedule Box */}
                  <div className="bg-purple-50/70 border border-purple-200/70 rounded-2xl p-3.5 space-y-1">
                    <p className="text-[10px] font-black uppercase tracking-wider text-purple-700 flex items-center gap-1.5">
                      📅 Current Schedule
                    </p>
                    <p className="text-sm font-bold text-gray-800">
                      {getApptScheduleDetails(actionModal.apt).dateStr}
                      {getApptScheduleDetails(actionModal.apt).timeStr !== "Not specified" && (
                        <span className="text-gray-500 font-normal"> at {getApptScheduleDetails(actionModal.apt).timeStr}</span>
                      )}
                    </p>
                  </div>

                  <div>
                    <div className="flex justify-between items-center mb-1">
                      <label className="block text-xs font-bold text-gray-700">Requested Reschedule Date <span className="text-red-500">*</span></label>
                      <span className="text-[10px] font-bold text-amber-700 bg-amber-50 px-2 py-0.5 rounded-full border border-amber-200">
                        Closed Mon
                      </span>
                    </div>
                    <input 
                      type="date"
                      min={getLocalDateString()}
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl outline-none"
                      value={actionForm.date}
                      onChange={e => {
                        const val = e.target.value;
                        const todayStr = getLocalDateString();
                        if (val) {
                          if (val < todayStr) {
                            setActionError("Reschedule date cannot be in the past. Please choose today or a future date.");
                            setActionForm({ ...actionForm, date: "" });
                            return;
                          }
                          const day = new Date(val + "T00:00:00").getDay();
                          if (day === 1) {
                            setActionError("The store is closed on Mondays. Please select another date.");
                            setActionForm({ ...actionForm, date: "" });
                            return;
                          }
                          for (const p of actionModal.apt?.pets || []) {
                            if (p.grooming?.date || p.grooming?.service) {
                              let bday = p.birthday;
                              if (!bday && (user?.pets || []).length > 0) {
                                const matchedPet = (user.pets || []).find(up => up._id === (p.pet || p._id));
                                if (matchedPet) bday = matchedPet.birthday;
                              }
                              if (bday && !isPetEligibleForGrooming(bday, val)) {
                                const minD = getPetMinGroomingDate(bday);
                                const minDStr = minD ? minD.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";
                                setActionError(`Furpect Tails is not accepting pets under 6 months old for grooming. ${p.petName || "Pet"} must be at least 6 months old (eligible starting ${minDStr}).`);
                                setActionForm({ ...actionForm, date: "" });
                                return;
                              }
                            }
                          }
                        }
                        setActionError(null);
                        const newForm = { ...actionForm, date: val };
                        if (actionForm.time && isTimeSlotPast(val, actionForm.time)) {
                          newForm.time = "";
                        }
                        setActionForm(newForm);
                      }}
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-700 mb-1">Requested Reschedule Time <span className="text-red-500">*</span></label>
                    <input 
                      type="time"
                      className="w-full px-4 py-3 border border-gray-200 rounded-xl outline-none"
                      value={actionForm.time}
                      onChange={e => {
                        setActionError(null);
                        setActionForm({ ...actionForm, time: e.target.value });
                      }}
                      required
                    />
                  </div>
                </>
              )}
              
              <div>
                <label className="block text-xs font-bold text-gray-500 mb-1">Reason <span className="text-red-500">*</span></label>
                <select 
                  className={`w-full px-4 py-3 border rounded-xl outline-none ${actionError && !actionForm.reason ? "border-red-400 bg-red-50" : "border-gray-200"}`}
                  value={actionForm.reason}
                  onChange={e => { setActionForm({ ...actionForm, reason: e.target.value }); setActionError(null); }}
                >
                  <option value="">-- Choose reason --</option>
                  <option value="Schedule conflict">Schedule conflict</option>
                  <option value="Change of mind">Change of mind</option>
                  <option value="Pet sick">Pet sick</option>
                  <option value="Transportation issue">Transportation issue</option>
                  <option value="Others">Others</option>
                </select>
              </div>
              
              {actionForm.reason === "Others" && (
                <div>
                  <label className="block text-xs font-bold text-gray-500 mb-1">Please specify <span className="text-red-500">*</span></label>
                  <input 
                    type="text"
                    className={`w-full px-4 py-3 border rounded-xl outline-none ${actionError && !actionForm.customReason.trim() ? "border-red-400 bg-red-50" : "border-gray-200"}`}
                    value={actionForm.customReason}
                    onChange={e => { setActionForm({ ...actionForm, customReason: e.target.value }); setActionError(null); }}
                    placeholder="Type your reason here..."
                  />
                </div>
              )}
            </div>

            {actionError && (
              <p className="mt-4 text-xs text-red-500 font-bold bg-red-50 border border-red-100 px-4 py-2 rounded-xl">⚠️ {actionError}</p>
            )}
            <div className="flex gap-3 mt-4">
              <button 
                onClick={handleCustomerActionSubmit} 
                className={`flex-1 py-3 text-white font-bold rounded-xl text-sm transition-colors ${
                  actionModal.type === "cancel" ? "bg-red-500 hover:bg-red-600" : "bg-orange-500 hover:bg-orange-600"
                }`}
              >
                Submit Request
              </button>
              <button 
                onClick={() => { setActionModal({ isOpen: false, apt: null, type: null }); setActionError(null); }} 
                className="flex-1 py-3 bg-gray-100 text-gray-600 font-bold rounded-xl text-sm hover:bg-gray-200 transition-colors"
              >
                Go Back
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Appointment Details Modal */}
      {appointmentDetailsModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60] flex items-center justify-center p-4" onClick={(e) => { if(e.target === e.currentTarget) setAppointmentDetailsModal(null); }}>
          <div className="bg-white rounded-3xl w-full max-w-lg shadow-2xl relative overflow-hidden flex flex-col max-h-[90vh]">
            <div className="flex items-center justify-between px-6 py-4 bg-gradient-to-r from-[#6992a5] to-[#5b7b88]">
              <h2 className="text-xl font-bold text-white flex items-center gap-2">
                <span>📋</span> Appointment Details
              </h2>
              <button onClick={() => setAppointmentDetailsModal(null)} className="w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 text-white font-bold flex items-center justify-center transition-colors">×</button>
            </div>
            
            <div className="p-6 overflow-y-auto space-y-6">
              <div className="flex items-center gap-4 pb-4 border-b border-gray-100">
                <div className="w-16 h-16 bg-[#e6eff2] rounded-xl flex items-center justify-center text-3xl overflow-hidden shrink-0">
                  {appointmentDetailsModal.pet.photoUrl ? <img src={appointmentDetailsModal.pet.photoUrl} alt="Pet" className="w-full h-full object-cover" /> : (appointmentDetailsModal.pet.petType === "cat" ? "🐱" : "🐶")}
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800">{appointmentDetailsModal.pet.petName}</h3>
                  <p className="text-sm text-gray-500 capitalize">{appointmentDetailsModal.pet.breed || "Mixed Breed"} • {appointmentDetailsModal.pet.petType}</p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100">
                  <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Service Type</p>
                  <p className="font-bold text-gray-800 capitalize">{appointmentDetailsModal.pet.serviceType === "both" ? "Hotel & Grooming" : appointmentDetailsModal.pet.serviceType}</p>
                </div>

                {appointmentDetailsModal.pet.grooming && appointmentDetailsModal.pet.grooming.service && (
                  <div className="bg-[#f8fafb] rounded-2xl p-4 border border-[#e1ebf0]">
                    <p className="text-xs font-bold text-[#5b7b88] uppercase tracking-wider mb-3">✂️ Grooming Details</p>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between"><span className="text-gray-500">Package:</span> <span className="font-bold text-gray-800">{appointmentDetailsModal.pet.grooming.service}</span></div>
                      {appointmentDetailsModal.pet.grooming.size && <div className="flex justify-between"><span className="text-gray-500">Size:</span> <span className="font-medium text-gray-800">{appointmentDetailsModal.pet.grooming.size}</span></div>}
                      {appointmentDetailsModal.pet.grooming.haircutStyle && <div className="flex justify-between"><span className="text-gray-500">Haircut:</span> <span className="font-medium text-gray-800">{appointmentDetailsModal.pet.grooming.haircutStyle}</span></div>}
                      <div className="flex justify-between"><span className="text-gray-500">Date:</span> <span className="font-medium text-gray-800">{appointmentDetailsModal.pet.grooming.date ? new Date(appointmentDetailsModal.pet.grooming.date).toLocaleDateString("en-PH") : "N/A"}</span></div>
                      <div className="flex justify-between"><span className="text-gray-500">Time:</span> <span className="font-medium text-gray-800">{appointmentDetailsModal.pet.grooming.time}</span></div>
                      <div className="flex justify-between mt-2 pt-2 border-t border-gray-200"><span className="font-bold text-gray-600">Grooming Price:</span> <span className="font-black text-gray-800">₱{appointmentDetailsModal.pet.grooming.price?.toLocaleString()}</span></div>
                    </div>
                  </div>
                )}

                {appointmentDetailsModal.pet.hotel && appointmentDetailsModal.pet.hotel.roomType && (
                  <div className="bg-amber-50/50 rounded-2xl p-4 border border-amber-100">
                    <p className="text-xs font-bold text-amber-700 uppercase tracking-wider mb-3">🏨 Hotel Details</p>
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between"><span className="text-gray-500">Room:</span> <span className="font-bold text-gray-800">{appointmentDetailsModal.pet.hotel.roomType}</span></div>
                      <div className="flex justify-between"><span className="text-gray-500">Duration:</span> <span className="font-bold text-blue-700">{appointmentDetailsModal.pet.hotel.stayDays || 1} day{(appointmentDetailsModal.pet.hotel.stayDays || 1) > 1 ? "s" : ""}</span></div>
                      <div className="flex justify-between"><span className="text-gray-500">Check-in:</span> <span className="font-medium text-gray-800">{appointmentDetailsModal.pet.hotel.checkInDate ? new Date(appointmentDetailsModal.pet.hotel.checkInDate).toLocaleDateString("en-PH") : "N/A"} at {appointmentDetailsModal.pet.hotel.checkInTime}</span></div>
                      <div className="flex justify-between"><span className="text-gray-500">Check-out:</span> <span className="font-medium text-gray-800">{appointmentDetailsModal.pet.hotel.checkOutDate ? new Date(appointmentDetailsModal.pet.hotel.checkOutDate).toLocaleDateString("en-PH") : "N/A"}{appointmentDetailsModal.pet.hotel.checkOutTime ? ` at ${appointmentDetailsModal.pet.hotel.checkOutTime}` : ""}</span></div>
                      {Boolean(appointmentDetailsModal.pet.hotel.exceedingHours) && (
                        <div className="flex justify-between text-purple-700 font-medium">
                          <span>Exceeding Time (₱50/hr):</span>
                          <span>+{appointmentDetailsModal.pet.hotel.exceedingHours} hr(s) (₱{(appointmentDetailsModal.pet.hotel.exceedingFee || appointmentDetailsModal.pet.hotel.exceedingHours * 50).toLocaleString()})</span>
                        </div>
                      )}
                      <div className="flex justify-between mt-2 pt-2 border-t border-amber-200"><span className="font-bold text-amber-800">Hotel Total:</span> <span className="font-black text-gray-800">₱{(appointmentDetailsModal.pet.hotel.totalPrice || 0).toLocaleString()}</span></div>
                    </div>
                  </div>
                )}

                {/* Purchased Add-Ons */}
                {appointmentDetailsModal.appt?.addOns?.length > 0 && (
                  <div className="bg-purple-50/60 rounded-2xl p-4 border border-purple-100 space-y-2">
                    <p className="text-xs font-bold text-purple-700 uppercase tracking-wider mb-2">🛍️ Purchased Add-Ons</p>
                    <div className="space-y-1.5 text-sm">
                      {appointmentDetailsModal.appt.addOns.map((item, idx) => (
                        <div key={idx} className="flex justify-between items-center">
                          <span className="text-gray-600">{item.name} ({item.variant}) ×{item.qty}</span>
                          <span className="font-bold text-gray-800">₱{(item.subtotal || (item.unitPrice * item.qty) || 0).toLocaleString()}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                <div className="flex justify-between items-center p-4 bg-gray-50 rounded-2xl border border-gray-200">
                  <span className="font-bold text-gray-600">Total Booking Price:</span>
                  <span className="text-xl font-black text-gray-800">₱{(appointmentDetailsModal.appt.totalPrice || 0).toLocaleString()}</span>
                </div>

                {/* Payment Info */}
                {(appointmentDetailsModal.appt.paymentMethod || appointmentDetailsModal.appt.referenceNumber) && (
                  <div className={`rounded-2xl p-4 border-2 space-y-3 ${
                    appointmentDetailsModal.appt.paymentMethod === "GCash" ? "bg-blue-50 border-blue-100" :
                    appointmentDetailsModal.appt.paymentMethod === "UnionBank" ? "bg-orange-50 border-orange-100" :
                    appointmentDetailsModal.appt.paymentMethod === "BDO" ? "bg-indigo-50 border-indigo-100" :
                    "bg-green-50 border-green-100"
                  }`}>
                    <p className={`text-xs font-black uppercase tracking-wider ${
                      appointmentDetailsModal.appt.paymentMethod === "GCash" ? "text-blue-700" :
                      appointmentDetailsModal.appt.paymentMethod === "UnionBank" ? "text-orange-700" :
                      appointmentDetailsModal.appt.paymentMethod === "BDO" ? "text-indigo-700" :
                      "text-green-700"
                    }`}>
                      💳 Downpayment Submitted
                    </p>
                    <div className="space-y-1.5 text-sm">
                      {appointmentDetailsModal.appt.paymentMethod && (
                        <div className="flex justify-between">
                          <span className="text-gray-500">Method:</span>
                          <span className="font-bold text-gray-800">{appointmentDetailsModal.appt.paymentMethod}</span>
                        </div>
                      )}
                      {appointmentDetailsModal.appt.downpaymentAmount > 0 && (
                        <div className="flex justify-between">
                          <span className="text-gray-500">Downpayment:</span>
                          <span className="font-bold text-purple-700">₱{(appointmentDetailsModal.appt.downpaymentAmount || 0).toLocaleString()}</span>
                        </div>
                      )}
                      {appointmentDetailsModal.appt.paymentMethod !== "Cash" && appointmentDetailsModal.appt.referenceNumber && appointmentDetailsModal.appt.referenceNumber !== "CASH" && (
                        <div className="flex justify-between">
                          <span className="text-gray-500">Reference #:</span>
                          <span className="font-bold font-mono text-gray-800">{appointmentDetailsModal.appt.referenceNumber}</span>
                        </div>
                      )}
                    </div>
                    {appointmentDetailsModal.appt.paymentScreenshot && (
                      <div>
                        <p className="text-xs font-bold text-gray-500 mb-1">Your Payment Screenshot:</p>
                        <div 
                          onClick={() => setZoomImage(appointmentDetailsModal.appt.paymentScreenshot)}
                          className="cursor-zoom-in group relative inline-block rounded-xl overflow-hidden"
                        >
                          <img
                            src={appointmentDetailsModal.appt.paymentScreenshot}
                            alt="Payment Screenshot"
                            className="w-full max-h-32 object-contain border-2 border-white bg-white shadow-sm"
                          />
                          <div className="absolute inset-0 bg-black/15 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                            <span className="text-white bg-black/70 px-2 py-0.5 rounded-full text-[10px] font-bold">🔍 Zoom</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Review & Experience in Details Modal */}
                {appointmentDetailsModal.appt?.status === "completed" && (
                  <div className="p-4 bg-gradient-to-r from-amber-50 to-yellow-50 rounded-2xl border-2 border-amber-200 space-y-2">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="text-xl">⭐</span>
                        <span className="font-black text-gray-800 text-sm">Your Experience &amp; Rating</span>
                      </div>
                      {appointmentDetailsModal.appt.rating ? (
                        <button
                          onClick={() => {
                            const currentApt = appointmentDetailsModal.appt;
                            setAppointmentDetailsModal(null);
                            setFeedbackModal({
                              isOpen: true,
                              apt: currentApt,
                              rating: currentApt.rating || 5,
                              feedback: currentApt.feedback || "",
                            });
                          }}
                          className="text-xs font-bold text-amber-800 hover:text-amber-950 bg-white px-3 py-1.5 rounded-xl border border-amber-300 shadow-2xs transition-colors"
                        >
                          ✏️ Edit Review
                        </button>
                      ) : (
                        <button
                          onClick={() => {
                            const currentApt = appointmentDetailsModal.appt;
                            setAppointmentDetailsModal(null);
                            setFeedbackModal({
                              isOpen: true,
                              apt: currentApt,
                              rating: 5,
                              feedback: "",
                            });
                          }}
                          className="text-xs font-bold text-white bg-gradient-to-r from-pink-500 to-rose-500 hover:opacity-90 px-3.5 py-1.5 rounded-xl shadow-sm transition-opacity"
                        >
                          ⭐ Leave Review
                        </button>
                      )}
                    </div>

                    {appointmentDetailsModal.appt.rating ? (
                      <div className="space-y-1.5 pt-1">
                        <div className="flex items-center gap-2">
                          <div className="flex text-yellow-400 text-base">
                            {[1, 2, 3, 4, 5].map((s) => (
                              <span key={s}>{s <= appointmentDetailsModal.appt.rating ? "★" : "☆"}</span>
                            ))}
                          </div>
                          <span className="text-xs font-black text-amber-900 bg-amber-100 px-2.5 py-0.5 rounded-full">
                            {appointmentDetailsModal.appt.rating} / 5
                          </span>
                          {appointmentDetailsModal.appt.reviewedAt && (
                            <span className="text-[10px] text-gray-400 font-medium">
                              · Reviewed on {new Date(appointmentDetailsModal.appt.reviewedAt).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
                            </span>
                          )}
                        </div>
                        {appointmentDetailsModal.appt.feedback ? (
                          <p className="text-gray-700 italic text-xs bg-white/80 p-2.5 rounded-xl border border-amber-100">
                            "{appointmentDetailsModal.appt.feedback}"
                          </p>
                        ) : (
                          <p className="text-[11px] text-gray-400 italic">No written comments provided.</p>
                        )}
                      </div>
                    ) : (
                      <p className="text-xs text-gray-500 font-medium pt-1">
                        You haven't reviewed this visit yet. Tell us how the salon did!
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="p-4 border-t border-gray-100 bg-gray-50 flex justify-end">
              <button onClick={() => setAppointmentDetailsModal(null)} className="px-6 py-2 bg-[#6992a5] hover:bg-[#5b7b88] transition-colors text-white font-bold rounded-xl text-sm">
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Feedback / Review Modal */}
      {feedbackModal.isOpen && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-in fade-in duration-200">
          <div className="bg-white rounded-3xl p-6 sm:p-8 w-full max-w-lg shadow-2xl relative border-2 border-pink-100">
            <button
              onClick={() => setFeedbackModal({ isOpen: false, apt: null, rating: 5, feedback: "" })}
              disabled={feedbackSaving}
              className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 font-bold flex items-center justify-center transition-colors text-lg"
            >
              &times;
            </button>

            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-2xl bg-pink-100 text-pink-600 flex items-center justify-center text-xl shadow-sm">
                ⭐
              </div>
              <div>
                <h2 className="text-xl sm:text-2xl font-black text-gray-800">
                  {feedbackModal.apt?.rating ? "Update Your Review" : "Rate Your Experience"}
                </h2>
                <p className="text-gray-500 text-xs font-medium">
                  How was the visit for {feedbackModal.apt?.pets?.map(p => p.petName).join(", ") || "your pet"}?
                </p>
              </div>
            </div>

            {/* Star Rating Selector */}
            <div className="my-6 text-center">
              <div className="flex justify-center gap-2 mb-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button 
                    key={star} 
                    type="button"
                    onClick={() => setFeedbackModal({ ...feedbackModal, rating: star })}
                    className={`text-4xl sm:text-5xl transition-transform hover:scale-125 focus:outline-none ${
                      star <= feedbackModal.rating ? "text-yellow-400 drop-shadow-sm" : "text-gray-200 hover:text-yellow-200"
                    }`}
                  >
                    ★
                  </button>
                ))}
              </div>
              <p className="text-xs font-black uppercase tracking-wider text-pink-600">
                {feedbackModal.rating === 1 && "Poor 😞"}
                {feedbackModal.rating === 2 && "Fair 😐"}
                {feedbackModal.rating === 3 && "Good 🙂"}
                {feedbackModal.rating === 4 && "Very Good 😊"}
                {feedbackModal.rating === 5 && "Excellent! 🌟"}
              </p>
            </div>

            {/* Quick tags */}
            <div className="mb-4">
              <p className="text-[11px] font-bold text-gray-500 uppercase tracking-wider mb-2">Quick Praise Tags</p>
              <div className="flex flex-wrap gap-1.5">
                {[
                  "Gentle groomers ✂️",
                  "Clean facilities 🧼",
                  "Friendly staff 🤗",
                  "On-time service ⏰",
                  "My pet was happy! 🐶",
                  "Highly recommended 💖",
                ].map((tag) => (
                  <button
                    key={tag}
                    type="button"
                    onClick={() => {
                      const current = feedbackModal.feedback.trim();
                      if (!current.includes(tag)) {
                        setFeedbackModal({
                          ...feedbackModal,
                          feedback: current ? `${current} · ${tag}` : tag,
                        });
                      }
                    }}
                    className="px-2.5 py-1 bg-pink-50 hover:bg-pink-100 text-pink-700 text-[11px] font-bold rounded-lg border border-pink-200 transition-colors"
                  >
                    + {tag}
                  </button>
                ))}
              </div>
            </div>

            {/* Feedback textarea */}
            <div className="mb-5">
              <label className="block text-xs font-bold text-gray-600 mb-1.5">
                Written Feedback &amp; Suggestions (Optional)
              </label>
              <textarea
                className="w-full px-4 py-3 border-2 border-gray-100 rounded-2xl outline-none focus:border-pink-400 text-xs sm:text-sm resize-none font-medium text-gray-700 bg-gray-50 focus:bg-white transition-colors"
                rows={3}
                value={feedbackModal.feedback}
                onChange={e => setFeedbackModal({ ...feedbackModal, feedback: e.target.value })}
                placeholder="Share your thoughts about the groomer, hotel room, or overall service..."
              />
            </div>

            {feedbackErr && (
              <p className="mb-4 text-xs text-red-500 font-bold bg-red-50 p-3 rounded-xl border border-red-100">
                {feedbackErr}
              </p>
            )}

            <div className="flex gap-3">
              <button 
                onClick={handleFeedbackSubmit} 
                disabled={feedbackSaving}
                className="flex-1 py-3 bg-gradient-to-r from-pink-500 to-rose-500 hover:opacity-90 text-white font-black rounded-xl text-xs sm:text-sm transition-opacity disabled:opacity-50 shadow-md"
              >
                {feedbackSaving ? "Saving..." : feedbackModal.apt?.rating ? "Update Review" : "Submit Review"}
              </button>
              <button 
                onClick={() => setFeedbackModal({ isOpen: false, apt: null, rating: 5, feedback: "" })} 
                disabled={feedbackSaving}
                className="flex-1 py-3 bg-white border-2 border-gray-100 text-gray-600 font-bold rounded-xl text-xs sm:text-sm hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Lightbox Image Zoom Overlay */}
      {zoomImage && (
        <div 
          className="fixed inset-0 bg-black/85 backdrop-blur-sm z-[100] flex items-center justify-center p-4 cursor-zoom-out animate-in fade-in duration-200"
          onClick={() => setZoomImage(null)}
        >
          <div 
            className="relative max-w-4xl max-h-[85vh] flex flex-col items-center justify-center animate-in zoom-in-95 duration-200"
            onClick={e => e.stopPropagation()}
          >
            <button 
              onClick={() => setZoomImage(null)}
              className="absolute -top-12 right-0 bg-white/20 hover:bg-white/30 text-white rounded-full w-10 h-10 flex items-center justify-center text-2xl font-bold transition-all shadow-md"
            >
              ×
            </button>
            <img 
              src={zoomImage} 
              alt="Zoomed" 
              className="max-w-full max-h-[80vh] rounded-2xl object-contain shadow-2xl border-4 border-white/10"
            />
            <p className="text-white/60 text-xs mt-3 font-semibold tracking-wider">Click anywhere outside to close</p>
          </div>
        </div>
      )}

      {/* ── Check-In QR Code Modal ── */}
      {checkInQrModal && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[90] flex items-center justify-center p-4"
          onClick={(e) => { if (e.target === e.currentTarget) setCheckInQrModal(null); }}
        >
          <div className="bg-white rounded-3xl p-6 sm:p-8 max-w-sm w-full shadow-2xl relative text-center animate-in zoom-in-95 duration-200 border-2 border-purple-100">
            <button 
              onClick={() => setCheckInQrModal(null)}
              className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 font-bold flex items-center justify-center transition-colors"
            >
              ×
            </button>

            <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-3 text-2xl shadow-inner">
              📱
            </div>

            <h3 className="text-xl font-black text-gray-800 mb-1">Check-In QR Code</h3>
            <p className="text-xs text-gray-500 mb-4 font-medium">
              Present this code to the staff upon arrival at Furpect Tails for instant check-in.
            </p>

            <div className="p-4 bg-white rounded-2xl border-2 border-dashed border-purple-300 flex flex-col items-center justify-center shadow-inner mb-4">
              <QRCodeSVG
                value={`${window.location.origin}/appointment/${checkInQrModal._id}`}
                size={180}
                level="M"
                includeMargin={false}
              />
              <p className="text-[10px] text-gray-400 font-mono mt-3 uppercase tracking-wider">
                Booking ID: {checkInQrModal._id?.slice(-8)}
              </p>
              <p className="text-[10px] text-purple-600 font-semibold mt-1">
                🛡️ Scanned by clinic staff at reception
              </p>
            </div>

            <div className="bg-purple-50 p-3 rounded-2xl text-xs space-y-1 mb-4 text-left">
              <div className="flex justify-between text-gray-700">
                <span className="text-gray-500">Pet(s):</span>
                <span className="font-bold">{checkInQrModal.pets?.map(p => p.petName).join(", ") || "My Pet"}</span>
              </div>
              <div className="flex justify-between text-gray-700">
                <span className="text-gray-500">Scheduled Date:</span>
                <span className="font-bold">
                  {checkInQrModal.appointmentDate ? new Date(checkInQrModal.appointmentDate).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "N/A"}
                </span>
              </div>
            </div>

            <button
              onClick={() => setCheckInQrModal(null)}
              className="w-full py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold rounded-xl text-xs shadow-md hover:opacity-95 transition-opacity"
            >
              Done
            </button>
          </div>
        </div>
      )}

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full p-8 text-center animate-in zoom-in duration-200">
            <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-4 text-xl">
              🐾
            </div>
            <h2 className="text-xl font-black text-gray-800 mb-2">Confirm Log Out</h2>
            <p className="text-gray-500 text-sm mb-6">Are you sure you want to log out of your account?</p>
            
            <div className="flex gap-3">
              <button 
                onClick={() => setShowLogoutConfirm(false)}
                className="flex-1 py-3 px-4 rounded-xl font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors text-sm"
              >
                Cancel
              </button>
              <button 
                onClick={() => {
                  setShowLogoutConfirm(false);
                  handleLogout();
                }}
                className="flex-1 py-3 px-4 rounded-xl font-bold text-white bg-red-500 hover:bg-red-600 shadow-lg shadow-red-500/30 transition-all text-sm"
              >
                Log Out
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default CustomerDashboard;
